import React, { useState, useRef, useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { alignNodesWithDagLayout } from "./helper";
import {
  MDBRow,
  MDBIcon,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBBtn,
  MDBAlert,
  MDBSpinner,
  MDBModalTitle,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBModal,
  MDBTextArea,
} from "mdb-react-ui-kit";
import useCopyPaste from "../../components/useCopyPaste.ts";
import {
  useUpdateNodeInternals,
  ReactFlowProvider,
  useReactFlow,
  Controls,
  Background,
  ReactFlow,
  reconnectEdge,
  addEdge,
  useNodesState,
  useEdgesState,
  MarkerType,
  getIncomers,
  getOutgoers,
  getConnectedEdges,
  applyNodeChanges,
  applyEdgeChanges,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import dagre from "dagre";
import PopupLoader from "../../views/popups/PopupLoader";
import BlackMode from "../NightMode/BlackTheme";
import cfNodesLib from "./nodeComponents.json";
import CFNodes from "./Nodes.js";
import CFFileMenu from "./FileMenu.js";
import CFAnalytics from "./CallAnalytics.js";
import {
  getExistingGreetingsInfo,
  getSpecificCallFlows,
  getSpecificHuntGroup,
  updateCallFlows,
  createCallFlowsSchedule,
  getBranchnodes,
  callflowFeedback,
  editUserExternGroup,
  confirmDeleteBlfGroupInPhones,
  getSpecificAAGroup,
} from "../../apiclients/streamsapi_bridge.js";
import AddCallerID from "../../views/popups/callflow/AddCallerID.js";
import AddHuntGroup from "../../views/popups/hunt/AddHuntGroup.js";
import AddACDGroup from "../../views/popups/acd/AddACDGroup.js";
import { nodeTypes } from "./nodeTypes.js";
import Greeting from "../../views/popups/mlib/Greeting.jsx";
import AddAAGroup from "../../views/popups/autoattendant/AddAAGroup.js";
import AddNewVMBox from "../../views/popups/callflow/AddNewVmailBox.js";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew.js";
import SchduleView from "./ScheduleView.js";
import useUndoRedo from "../UndoRedo.ts";
import WeelySchedulePopup from "./WeelySchedulePopup.js";
import { RedoImg, RefreshNew, UndoImg } from "../images/index.js";
import EditCallerID from "../../views/popups/callflow/EditCallerID.js";
import { getAudioFile, getAudioFileForTTS } from "../mediaplayers/AudioPlayer.js";

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

const hide = (hidden) => (nodeOrEdge) => {
  if (nodeOrEdge.type == "notes") nodeOrEdge.hidden = hidden;
  return nodeOrEdge;
};

function CallFlow(props) {
  /**
   * Constants
   */
  const navigate = useNavigate();
  const updateNodeInternals = useUpdateNodeInternals();
  const [isEdited, setIsEdited] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const { undo, redo, canUndo, canRedo, takeSnapshot } = useUndoRedo();
  const [callflow, setCallflow] = useState({});
  const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [callerFilter, setCallerFilter] = useState(false);
  const [callerEditFilter, setCallerEditFilter] = useState(false);
  const [editSpechandle, setEditSpechandle] = useState({});
  const [updatedCId, setupdatedCId] = useState({});
  const [editGreeting, setEditGreeting] = useState(false);
  const [newSchedule, setNewSchedule] = useState(false);
  const [editSchedule, setEditSchedule] = useState(false);
  const [newHuntGroup, setNewHuntGroup] = useState(false);
  const [newAAGroup, setNewAAGroup] = useState(false);
  const [newACDGroup, setNewACDGroup] = useState(false);
  const [newVMBox, setNewVMBox] = useState(false);
  const { getNodes } = useReactFlow();
  const [nodes, setNodes] = useNodesState([]);
  const [edges, setEdges] = useEdgesState([]);
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [showAnalyticsLabel, setShowAnalyticsLabel] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [existingGreetings, setExistingGreetings] = useState([]);
  const addHuntRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [refresh, setRefresh] = React.useState(false);
  const scheduleEditRef = useRef();
  const [scheduleEditError, setScheduleEditError] = useState(false);

  const ColorTheme = localStorage.getItem('selectedColorTheme');

  let color;

  if (ColorTheme === 'dark') {
    color = '#FFFFFF';
  } else if (ColorTheme === 'light') {
    color = '#000000';
  } else if (ColorTheme === 'system') {
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    color = systemPrefersDark ? '#FFFFFF' : '#000000';
  }


  const forceUpdate = () => {
    setRefresh((prev) => !prev); // Toggles the state to force re-render
    const reactFlowElement = document.querySelector(".react-flow"); // Adjust the selector as needed
    if (reactFlowElement) {
      reactFlowElement.dispatchEvent(
        new MouseEvent("click", { bubbles: true })
      );
    }
  };
 
  //const { fitView } = useReactFlow();
  const onNodesChange = useCallback((changes) => {
    setTimeout(() => {
      setNodes((nodes) => applyNodeChanges(changes, nodes));
    }, 0);
    // const positionsReady = nodes.every(n => n.position?.x != null && n.position?.y != null);
    // if (positionsReady) {
    //   setTimeout(() => fitView({ padding: 0.1 }), 0);
    // }
  }, []);

  const onEdgesChange = useCallback((changes) => {
    setTimeout(() => {
      setEdges((edges) => applyEdgeChanges(changes, edges));
    }, 0);
  }, []);

  function handleClick() {
    addHuntRef.current.click();
  }
  const mousePosRef = useRef({ x: 0, y: 0 });
  const { setViewport, zoomIn, zoomOut } = useReactFlow();
  const { cut, copy, paste, bufferedNodes } = useCopyPaste();
  const cpaste = useCallback(
    (
      { x: pasteX, y: pasteY } = reactFlowInstance.screenToFlowPosition({
        x: mousePosRef.current.x,
        y: mousePosRef.current.y,
      })
    ) => {
      const minX = Math.min(...bufferedNodes.map((s) => s.position.x));
      const minY = Math.min(...bufferedNodes.map((s) => s.position.y));
      const newNodes = bufferedNodes.map((node) => {
        const id = new Date().getTime() + "";
        const x = pasteX + (node.position.x - minX);
        const y = pasteY + (node.position.y - minY);

        const cfNode = JSON.parse(JSON.stringify(cfNodesLib[node.type]));
        // Deep copy the data while preserving function references
        const data = {
          ...node.data,
          actionExecutor: (taction) => performAction(cfNode, taction),
        };

        // Assign the onDelete function separately
        data.onDelete = () => {
          onDeleteNode(id, true);
        };

        return {
          ...cfNode,
          id,
          data,
          height: node.style.height || cfNode.style.height,
          width: node.style.width || cfNode.style.width,
          position: { x, y },
        };
      });
      const tPnodes = registerAction(newNodes);
      addNodes(tPnodes);
      onRNodeClick(null, newNodes[0]);
      takeSnapshot();
    }
  );
  const canCopy = nodes.some(({ selected, type }) =>
    type === "scheduleNode" || type === "huntNode" || type === "attendantNode"
      ? false
      : selected
  );

  const canPaste = bufferedNodes.length > 0;

  const handleTransform = () => {
    if (reactFlowInstance) {
      reactFlowInstance.fitView({ padding: 0.1, duration: 800 });
    }
  };

  const handleCenterTransform = useCallback(() => {
    setViewport({ x: 0, y: 30, zoom: 1 }, { duration: 800 });
  }, [setViewport]);

  const zoomInFunction = (e) => {
    zoomIn({ duration: 800 });
  };
  const zoomOutFunction = (e) => {
    zoomOut({ duration: 800 });
  };

  const toggleNotes = (e) => {
    setHidden(!hidden);
  };

  const toggleCFilter = (node) => {
    setCallerFilter(!callerFilter);
  };
  const toggleEditFilter = (node) => {
    setCallerEditFilter(!callerEditFilter);
  };
  const toggleCFilterEGreet = (node) => {
    setEditGreeting(!editGreeting);
  };

  const handleClose = (popup) => {
    console.log(currentNode);
    console.log(currentNode.data.selected_object);

    if (
      currentNode &&
      currentNode.data &&
      currentNode.data.selected_object &&
      Object.keys(currentNode.data.selected_object).length > 1
    ) {
      performAction(currentNode, {
        action: 3,
        value: JSON.parse(JSON.stringify(currentNode.data.selected_object)),
      });
    }

    switch (popup) {
      case "schedule":
        toggleNewSchedule();
        break;
      case "schedule-edit":
        {
          toggleEditSchedule();
        }
        break;
      case "hunt":
        {
          toggleNewHunt();
        }
        break;
      case "acd":
        {
          toggleNewACD();
        }
        break;
      case "aa":
        {
          toggleNewAA();
        }
        break;
      case "vmail":
        {
          toggleNewVMBox();
        }
        break;
      case "cf":
        {
          toggleCFilter();
        }
        break;
      case "greeting":
        {
          toggleCFilterEGreet();
        }
        break;
      case "cfEdit": {
        toggleEditFilter();
      }
    }
  };
  const toggleNewSchedule = () => {
    console.log(newSchedule);
    setNewSchedule(!newSchedule);
  };
  const [schd, setSchd] = useState({});
  const toggleEditSchedule = (dataoBJ) => {
    getcurrentnode();
    setSchd(dataoBJ);
    setEditSchedule(!editSchedule);
  };

  const toggleNewHunt = () => setNewHuntGroup(!newHuntGroup);
  const toggleNewAA = () => setNewAAGroup(!newAAGroup);
  const toggleNewACD = () => setNewACDGroup(!newACDGroup);
  const toggleNewVMBox = () => setNewVMBox(!newVMBox);
  const [selectedNodes, setSelectedNodes] = useState([]);

  const defaultEdgeOptions = {
    type: "smoothstep",
    style: {
      stroke: "#009D44",
    },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 20,
      height: 20,
      color: "#009D44",
    },
    pathOptions: { offset: 15 },
  };
  const [errorNodes, setErrorNodes] = useState([]);

  const greetingSuccess = async (data, currentTab) => {
    toggleCFilterEGreet();

    const isAnnouncementNode = currentNode.type === "announcementNode";

    // Shared greetInfo shape used for both TTS and uploadType===3 cases
    const buildGreetInfo = () => ({
      voice_type: data.voice_type,
      text: data.text,
      uploadType: 3,
      title: data.name ?? data.display,
      display: data.name ?? data.display,
      greeting_id: data.greeting_id,
      greeting_type: data?.greeting_type,
      greeting_mode: 1,
      id: data?.id,
      filename: data.updatedfilename ?? data.filename ?? "",
      greetingSettingType:data.greetingSettingType ?? 5,
      code:data.code ?? data.greeting_id 

    });

    if (data?.istts) {
      const currentnodedata = {
        ...currentNode.data.selected_object,
        greeting_id: data?.greeting_id ?? "",
        greeting_type: data?.greeting_type ?? "",
      };

      if (isAnnouncementNode) {
        currentNode.data = { info: { pre_announce: { greeting_mode: currentTab } } };
        performAction(currentNode, { action: 3, value: data });
      } else {
        performAction(currentNode, { action: 3, value: currentnodedata });
      }

      const greetInfo = buildGreetInfo();
      console.log("this is preannounve :::: " + JSON.stringify(currentNode.data));

      // Resolve previous TTS greet for cache/delta logic in getAudioFileForTTS
      const prevTTSGreet = !data?.isNew
        ? isAnnouncementNode
          ? (currentNode?.data?.greet_info?.uploadType === 3 ? currentNode.data.greet_info : null)
          : (currentNode.data.greetinfo?.pre_announce?.uploadType === 3 ? currentNode.data.greetinfo.pre_announce : null)
        : null;

      const response = await getAudioFileForTTS(
        data?.uniqueId, data?.greeting_type, data?.greeting_id, data?.fileName, null, prevTTSGreet
      );

      if (response?.status === 200) {
        const blobfile = await response.blob();
        const audioUrl = URL.createObjectURL(blobfile);
        setAudioPlayerPath(data?.greeting_id == 0 ? "" : audioUrl, blobfile);
      }

      // Both branches were identical before — simplified to direct assignment
      if (isAnnouncementNode) {
        currentNode.data.greet_info = greetInfo;
      } else if (currentNode.data.greetinfo) {
        currentNode.data.greetinfo.pre_announce = greetInfo;
      } else {
        currentNode.data.greetinfo = { pre_announce: greetInfo };
      }
    }

    if (currentTab == 2 && data?.greeting_id == 0) {
      currentNode.data.selected_object.g_path = "";
    }

    if (!data?.istts) {
      if (data?.uploadType === 3) {
        const greetInfo = buildGreetInfo();
        if (isAnnouncementNode) {
          if (currentNode.data.greet_info) {
            currentNode.data.greet_info = greetInfo;
          } else {
            currentNode.data = { ...currentNode.data, greet_info: greetInfo };
          }
        } else if (currentNode.data.greetinfo) {
          currentNode.data.greetinfo.pre_announce = greetInfo;
        } else {
          currentNode.data.greetinfo = { pre_announce: greetInfo };
        }
      } else {
        currentNode.data[isAnnouncementNode ? "greet_info" : "greetinfo"] = null;
      }

      if (isAnnouncementNode) {
        currentNode.data = { ...currentNode.data, info: { pre_announce: { greeting_mode: currentTab } } };
        performAction(currentNode, { action: 3, value: data });
      }
    }  
    if(currentNode.type !== "announcementNode") {
        setNodes((els) =>
          els.map((el) => {
            if (el.id === currentNode.id) {
              el.data.info.pre_announce.greeting_mode = currentTab;
              el.data.info.pre_announce.display = data?.display;
            }
            return el;
          })
        );
      }
    
  };
  const setAudioPlayerPath = (data, fileObj) => {
    console.log(JSON.stringify(data));
    setAsActive(null, currentNode);
    currentNode.data.selected_object.g_path = data + "";
    currentNode.data.selected_object.g_wav_file = fileObj;
    performAction(currentNode, {
      action: 3,
      value: { ...currentNode.data.selected_object },
    });
  };
  const setPlayerPath = (data, fileObj) => {
    if (data) {
      console.log(JSON.stringify(data));
      setAsActive(null, currentNode);
      currentNode.data.selected_object.g_path = data + "";
      if(fileObj) {
      currentNode.data.selected_object.g_wav_file = fileObj;
    }
      performAction(currentNode, {
        action: 3,
        value: { ...currentNode.data.selected_object },
      });
    }
  };
  const setgeetingTitle = (data) => {

    console.log(JSON.stringify(data));
    if (currentNode.data.selected_object && data) {
      setAsActive(null, currentNode);
      performAction(currentNode, {
        action: 3,
        value: {
          ...currentNode.data.selected_object,
          display: data + ""
        },
      });
    }
  };

  const onLayout = useCallback(
    (direction) => {
      const { nodes: layoutedNodes } = alignNodesWithDagLayout(
        nodes,
        edges,
        "LR"
      );
      setNodes(layoutedNodes);
      takeSnapshot();
    },
    [nodes, edges]
  );

  async function getcurrentnode() {
    const response = await getSpecificCallFlows(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      JSON.parse(localStorage.getItem("veditor_cfid")).call_flow_id
    );
    if (!response.json) {
      return;
    }
    const rawData = await response.json();
    let schedule = rawData.nodes.nod.find(n => n.id === "scheduleNode");
    seteditcurrent(schedule)
  }
  const onNewSchedule = async (tnewObjInfo, tnode, saveFlag) => {
    props.showload("true");
    const updates = {
      reqid: 60,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      call_flow_id: callflow.call_flow_id,
      name: callflow.name,
      schedule_id: tnewObjInfo.schedule_id,
      schedule_name: tnewObjInfo.schedule_name,
      timezone: tnewObjInfo.timezone,
      schedule: {
        all_time: tnewObjInfo.all_time,
        weekly_schedule: tnewObjInfo.weekly_schedule,
      },
      overrides: tnewObjInfo.overrides,
      holidays: tnewObjInfo.holidays,
    };

    let saverep = await createCallFlowsSchedule(updates);
    let saverepeMsg = await saverep.json();
    console.log("saverepeMsg ::::::::::::::", saverepeMsg)
    if (saverepeMsg.message.errors && saverepeMsg.message.errors.length > 0) {
      setErrorNodes([currentNode]);
      props.onmsg();
      return;
    }
    tnewObjInfo.schedule_type = 2;
    let tmpObj = {
      label: saverepeMsg.name,
      title: saverepeMsg.name,
      id: callflow.call_flow_id,
      isnewshcedule: 1,
      code: saverepeMsg.schedule_id,
      schedule_id: saverepeMsg.schedule_id,
      schedule_type: 2,
      value: tnewObjInfo,
    };
    currentNode.data.selected_object = tmpObj;
    performAction(currentNode, {
      action: 3,
      value: tmpObj,
      newflag: 1,
    });
    performAction(currentNode, { action: 2, value: tnewObjInfo, newflag: 1 });
    props.showload("false");

    /**
     * Added to save as draft
     */
    setNodes((nds) => {
      return nds.map((nd) => {
        if (nd.id === currentNode.id) {
          let temp_handles = getHandles(
            {
              action: 3,
              value: tmpObj.value,
              newflag: 1,
            },
            nd
          );
          let temp_node = {
            ...nd,
            data: {
              ...nd.data,
              handles: temp_handles,
            },
          };
          setTimeout(() => {
            updateNodeInternals(nd.id);
            saveAsDrafWithNomessage(temp_node);
          }, 500);
          return temp_node;
        }
        return nd;
      });
    });
  };

  const updateVE = async (data, tnode) => {
    console.log(data);
    console.log(tnode);
    setNodes((els) => {
      return els.map((el) => {
        if (el.id === tnode.id) {
          el.data.selected_object = {
            title: data.name,
            label: `${data.name} : ${data.extension} `,
            code: data.code ? data.code : data.uniqueId,
            isnew: 1,
            entity_type : data?.entity_type,
            uniqueId : data.code ? data.code : data.uniqueId
          };
        }
        return el;
      });
    });
    performAction(tnode, {
      action: 3,
      value: {
        title: data.name,
        label: `${data.name} : ${data.extension} `,
        code: data.code ? data.code : data.uniqueId,
        entity_type : data?.entity_type,
        isnew: 1,
        uniqueId : data.code ? data.code : data.uniqueId
      },
    });
    // setTimeout(() => {
    performAction(tnode, {
      action: 7,
      value: {
        title: data.name,
        label: `${data.name} : ${data.extension} `,
        code: data.code ? data.code : data.uniqueId,
        entity_type : data?.entity_type,
        isnew: 1,
        uniqueId : data.code ? data.code : data.uniqueId
      },
    });
    //  }, 5000);
    // regHuntNodeActions(
    //   tnode.id,
    //   { action: 2, value: { title: data.name, code: data.name } },
    //   tnode
    // );
    if (data?.code) {
      const response = await getSpecificAAGroup(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        data?.code
      );
      const rawData = await response.json();
      if (!rawData) {
        window.alert(`info with id  not found`);
      }
      console.log(rawData);
      setNodes((els) => {
        return els.map((el) => {
          if (el.id === tnode.id) {
            el.data.info = rawData.greetings;
            console.log("current match AA :::" , JSON.stringify(el));
          }
          return el;
        });
      });
    }
    props.onssmesg();
  };

  const proOptions = { account: "paid-pro", hideAttribution: true };

  const onDeleteNode = (node, selfflag) => {
    takeSnapshot();
    setNodes((els) => {
      let targetNodeIds = [];
      let targetEdgeIds = [];
      setEdges((eds) => {
        console.log(eds);
        targetNodeIds = getAllSubNodeIds(node, eds, selfflag);
        console.log(targetNodeIds);
        targetEdgeIds = eds
          .filter((edge) => targetNodeIds.includes(edge.target))
          .map((edge) => edge.id);
        setNodes((sbnds) => {
          targetNodeIds = getAllSubNodeIds(node, eds, selfflag);

          console.log(
            "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"
          );
          console.log(targetNodeIds);
          return sbnds.filter((en) => !targetNodeIds.includes(en.id));
        });
        return eds.filter((e) => !targetEdgeIds.includes(e.id));
      });
      return els.filter((e) => !targetNodeIds.includes(e.id));
    });
    updateNodeInternals(node);
    // if (selfflag) {
    //   setNodes((els) => els && els.filter((el) => el.id !== node));
    //   setEdges((eds) =>
    //     eds.filter((edge) => edge.source !== node && edge.target !== node)
    //   );
    // }
    // handleDelNode(node);
  };

  const handleDelNode = (node) => {
    let nodes = node.data.nodes;
    let edges = node.data.edges;

    // Find edges where the clicked node is the source
    const outgoingEdges = edges.filter((edge) => edge.source === node.id);

    // Get the target node IDs from these edges
    const targetNodeIds = outgoingEdges.map((edge) => edge.target);

    // Filter out target nodes but keep the node with id 'xxx'
    const newNodes = nodes.filter(
      (node) => !targetNodeIds.includes(node.id) || node.id === "scheduleNode"
    );

    // Remove edges that connect to target nodes except for 'xxx'
    const newEdges = edges.filter(
      (edge) =>
        !targetNodeIds.includes(edge.target) || edge.target === "scheduleNode"
    );

    // Update the state with the new nodes and edges
    setNodes(newNodes);
    setEdges(newEdges);
  };
  // Handler function for deleting an element (used for removing existing edge targets)
  const onDelete = (elementsToDelete) => {
    const updatedElements = edges.filter(
      (edge) => edge.id !== elementsToDelete
    );
    setEdges(updatedElements);
  };
  const [currentNode, setCurrentNode] = useState();
  const [editcurrent, seteditcurrent] = useState({})
  const [nHeight, setNHeight] = useState();
  const [hdata, setHdata] = useState({});
  const [nodeComponents, setNodeComponents] = useState([]);
  function getMaxId(arr) {
    if (arr && arr !== "undefined" && Array.isArray(arr)) {
      let maxValue = Number.MIN_VALUE;
      for (const element of arr) {
        const elementId = Number(element.id);
        if (element && !isNaN(elementId)) {
          if (elementId > maxValue) {
            maxValue = elementId;
          }
        }
      }
      return maxValue === Number.MIN_VALUE ? 0 : maxValue;
    } else {
      return 0;
    }
  }
  const addCFilter = (e, tlabel, tvalue, flag) => {
    if (flag == 1) {
      try {
        setNodes((nds) => {
          return nds.map((nd) => {
            if (nd.id === currentNode.id) {
              const editHandle = nd.data.handles.find(
                (handle) => handle.id === editSpechandle.id
              );
              editHandle.name = tlabel;
              editHandle.label = tlabel;
              editHandle.value = tvalue;
              setupdatedCId(editHandle);
              console.log("after update :::", JSON.stringify(editHandle));
              performAction(nd, {
                action: 2,
                name: tlabel,
                value: tvalue,
                flag: 1,
              });
            }
            return nd;
          });
        });
      } catch (e) {
        console.log(
          "No matching handle found for the given editSpechandle id.",
          e
        );
      }

      toggleEditFilter();
    } else {
      setNodes((nds) => {
        return nds.map((nd) => {
          if (nd.id === currentNode.id) {
            performAction(nd, { action: 2, name: tlabel, value: tvalue });
          }
          return nd;
        });
      });
      toggleCFilter();
    }
  };
  function traverseJson(obj, seen = new WeakMap()) {
    if (
      typeof obj === "object" &&
      obj !== null &&
      obj.type !== "default" &&
      obj + "" !== "[object, Object]"
    ) {
      if (seen.has(obj)) {
        return { ...seen.get(obj) }; // Return a shallow copy of the already seen object
      }

      const clone = Array.isArray(obj) ? [] : {};
      seen.set(obj, clone); // Store reference before recursion to prevent loops

      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          clone[key] = traverseJson(obj[key], seen);
        }
      }

      return clone;
    } else if (typeof obj === "string") {
      return obj;
    } else if (typeof obj === "symbol") {
      return "Symbol()";
    } else if (typeof obj === "function") {
      return "";
    } else if (obj === undefined) {
      return -1;
    } else {
      return obj; // Handle other data types as needed
    }
  }

  const toggleAnalytics = () => {
    alert("Not available at this moment");
    // setShowAnalytics(!showAnalytics);
  };
  const toggleAnalyticsLabel = () => {
    setShowAnalyticsLabel(!showAnalyticsLabel);
  };
  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  const createNode = (type, sNode, nodetdata) => {
    let tnodeid = createCFNode(type, {
      x: sNode.position.x + 210 + 50,
      y: sNode.position.y + 30,
    });

    createEdge(sNode.id, tnodeid, "source_1", "target");
    return tnodeid;
  };
  const createEdge = (sourceId, targetId, sourceHandle, targetHandle) => {
    setEdges((edgs) =>
      edgs.concat({
        id: `${sourceId}-${nodes.length}`,
        source: sourceId,
        sourceHandle: sourceHandle,
        targetHandle: targetHandle,
        target: targetId,
        type: "smoothstep",
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: 20,
          height: 20,
          color: "#009D44",
        },
        pathOptions: { offset: 15 },
        animated: false,
        style: {
          stroke: "#009D44",
        },
      })
    );
    takeSnapshot();
  };
  const getHuntDependentNodes = async (hcode, sNode, tRnode, nodetdata) => {
    const response = await getSpecificHuntGroup(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      hcode
    );
    if (!response.json) {
      return;
    }
    let rawData = await response.json();
    console.log(rawData);
    let newNid = -1;
    if (rawData && rawData.routing) {
      if (rawData.routing.busy_or_no_answer) {
        let dest = rawData.routing.busy_or_no_answer.destination_type;

        switch (rawData.routing.busy_or_no_answer.destination_type) {
          case 6:
            newNid = createNode("voicemailNode", sNode, nodetdata);
            break;
          case 0:
            newNid = createNode("userExtensionNode", sNode, nodetdata);
            break;
          case 2:
            break;
          case 3:
            break;
          case 4:
            break;
        }
      }
    }
    console.log(newNid);
    localStorage.setItem("prev_id", newNid);
    nodetdata.nid = newNid;
    setHdata(nodetdata);
  };

  const moveObjectToEnd = (arr, nameToMatch) => {
    // Find the index of the object
    const index = arr.findIndex((obj) => obj.label.includes(nameToMatch));

    // If the object is found
    if (index !== -1) {
      // Remove the object from the array
      const [objectToMove] = arr.splice(index, 1);

      // Add it to the end of the array
      arr.push(objectToMove);
    }

    return arr;
  };

  const updateEdges = (nodeId, newHandles) => {
    setEdges((eds) =>
      eds.map((edge) => {
        return edge;
      })
    );
  };

  // Helper function to get the corresponding new handle
  const getUpdatedHandleId = (oldHandle, newHandles) => {
    return newHandles.includes(oldHandle) ? oldHandle : newHandles[0]; // Default to the first new handle
  };

  const getHandles = (actionInfo, cNode) => {
    let handles = [];
    console.log(actionInfo);
    if (cNode.type === "scheduleNode") {
      if (actionInfo.newflag) {
        if (actionInfo.value.all_time) {
          console.log("in if");
          handles = [{ id: "1", label: "24/7", name: "24/7", value: "1" }];
        } else {
          console.log("in else");
          handles = [
            { id: "1", label: "Open", name: "Open", value: "1" },
            { id: "2", label: "Closed", name: "Closed", value: "2" },
          ];
        }
        let ordslength = 0;
        let maxId = Math.max(
          ...cNode.data.handles.map((item) => item.id),
          2 +
          (actionInfo.value.overrides
            ? actionInfo.value.overrides.add_overrides.length
            : 0) +
          1
        );
        if (
          actionInfo.value.overrides &&
          actionInfo.value.overrides.add_overrides.length > 0
        ) {
          // Deduplicate by name so each unique override name gets exactly one handle
          const uniqueOverrides = actionInfo.value.overrides.add_overrides.filter(
            (item, idx, arr) => arr.findIndex((o) => o.name === item.name) === idx
          );
          uniqueOverrides.map((item) => {
            const matchingItem = cNode.data.handles.find(
              (old) => old.label === item.name
            );
            let tid = matchingItem ? matchingItem.id : ++maxId;
            console.log("tid::: " + tid);
            handles = [
              ...handles,
              {
                id: tid * 1,
                label: item.name,
                name: item.name,
                value: tid * 1,
              },
            ];
          });
        }
        if (
          actionInfo.value.holidays &&
          actionInfo.value.holidays.add_holidays.length > 0
        ) {
          const matchingItemh = cNode.data.handles.find(
            (old) => old.label === "Holiday"
          );
          let tfound = handles.find(
            (old) => old.id === matchingItemh && matchingItemh.id
          );
          // actionInfo.value.holidays.add_holidays.map((item, index) => {
          console.log(tfound);
          let htid = matchingItemh && !tfound ? matchingItemh.id : ++maxId;
          console.log("htid::: " + htid);
          handles = [
            ...handles,
            {
              id: htid,
              label: "Holiday",
              name: "Holiday",
              value: htid,
            },
          ];
          // });
        }
      } else {
        handles = actionInfo.value;
      }
      console.log(handles);
      // const map2 = new Map(handles.map((item) => [item.id, item]));
      // let remHandles = cNode.data.handles.filter((item) => !map2.has(item.id));
      // remHandles.map((rmItem) => {
      //   performAction(cNode, { action: 15, value: rmItem.id });
      // });
      return handles;
    }
    if (cNode.type === "huntNode") {
      handles = [
        {
          id: "1",
          name: "Busy/No Answer",
          label: "Busy/No Answer",
          value: "1",
          default: true,
        },
      ];
    }
    if (cNode.type === "acdQueueNode") {
      handles = [
        { name: "No agents logged in" },
        { name: "Max callers exceeded" },
        { name: "Wait timeout" },
      ];
    }

    if (cNode.type === "attendantNode") {
      let optionsArray = [
        "Timeout",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "*",
        "#"
      ];

      function findFirstMismatch(optionsArray, labels) {
        const valueLabels = labels.map((item) => item.label);
        for (let i = 0; i < optionsArray.length; i++) {
          const option = optionsArray[i];
          if (!valueLabels.includes(option)) {
            console.log("First mismatch value:", option);
            return option; // Return the first mismatch value
          }
        }
        console.log("No mismatch found.");
        return null;
      }
      console.log("values :::::", actionInfo.value);
      if (actionInfo.deleteHId == 0 || actionInfo.deleteHId) {
        handles = cNode.data.handles.filter(
          (eHandles) => eHandles.id != actionInfo.deleteHId
        );
      } else {
        let handleId =
          actionInfo.value.length === 1
            ? "0"
            : // : actionInfo.value.length === 11
            // ? "*"
            // : actionInfo.value.length === 12
            // ? "#"
            findFirstMismatch(optionsArray, actionInfo.value);
        console.log("handleId :::::", handleId);
        handles = [
          ...actionInfo.value,
          {
            id: handleId.toString(),
            value: handleId.toString(),
            isselect: true,
            class: "handletextSelect",
            top: 210,
            label: handleId.toString(),
          },
        ];
        console.log(" after edit handleId :::::", handles);
      }
    }

    if (cNode.type == "callerIdNode") {
      if (actionInfo.flag == 1 && cNode.data.handles) {
        const updatedHandles = cNode.data.handles.map((handle) => {
          if (handle.id === editSpechandle.id) {
            return { ...handle, ...editSpechandle };
          }
          return handle;
        });
        cNode.data.handles = updatedHandles;
        handles = [...cNode.data.handles];
        console.log("Updated currentNode:", JSON.stringify(currentNode));
        return handles;
      }
      if (actionInfo.deleteHId) {
        handles = actionInfo.handles.filter(
          (eHandles) => eHandles.id !== actionInfo.deleteHId
        );
        cNode.data.handles = handles;
        console.log("callerId handles::::", handles);
        console.log("Updated currentNode:", JSON.stringify(cNode));
        return handles;
      }
      let hId = 0 + ""; // Default handle ID
      console.log("-------------------");
      console.log(cNode);
      if (cNode.data.handles) {
        hId = getMaxId(cNode.data.handles) + 1 + "";
        handles = [
          {
            id: hId,
            name: actionInfo.name,
            label: actionInfo.name,
            deletable: true,
            value: actionInfo.value,
            top: 140,
          },
          ...cNode.data.handles,
        ];
        console.log("callerId handles::::", handles);
      } else {
        handles = [
          {
            id: "minus1",
            name: "No Matches",
            label: "No Matches",
            deletable: false,
            value: "minus1",
            top: 120,
          },
        ];
      }
      return handles;
    }
    if (cNode.type === "externalNumberNode") {
      handles = actionInfo.value;
    }
    return handles;
  };

  const getHeight = (ntype) => {
    switch (ntype) {
      case "callerIdNode":
        return 210;
      case "scheduleNode":
        return 150;
      case "huntNode":
        return 160;
      case "attendantNode":
        return 300;
      default:
        return 200; // Default value
    }
  };

  const autoResizeNode = (cNode) => {
    let theight = 200;
    setNodes((els) =>
      els.map((el) => {
        if (el && el.type == "externalNumberNode") {
          Object.assign(el, {
            ...el, // Spread the existing styles
            height: `${250}px`, // Set the new height
          });
        }
        if (
          el &&
          (el.type == "callerIdNode" ||
            el.type == "scheduleNode" ||
            el.type == "attendantNode")
        ) {
          theight = getHeight(el.type);
          if (
            cNode.data.handles &&
            cNode.id == el.id &&
            cNode.data.handles.length > 1
          ) {
            theight = theight + (el.data.handles.length + 1) * 22;
            Object.assign(cNode.style, {
              ...cNode.style, // Spread the existing styles
              height: `${theight}px`, // Update the height
            });
            Object.assign(cNode, {
              ...cNode, // Spread the existing styles
              height: `${theight}px`, // Set the new height
            });
            Object.assign(el.style, {
              ...el.style, // Spread the existing styles
              height: `${theight}px`, // Update the height
            });
            Object.assign(el, {
              ...el, // Spread the existing styles
              height: `${theight}px`, // Set the new height
            });
          }
          if (
            cNode.data.handles &&
            cNode.id == el.id &&
            el.data.handles &&
            el.data.selected_object &&
            el.data.selected_object.isnew * 1 == 1
          ) {
            console.log("going here also..");
            theight = theight + (el.data.handles.length + 1) * 22;
            Object.assign(el.style, {
              ...el.style, // Spread the existing styles
              height: `${theight}px`, // Set the new height
            });
            Object.assign(el, {
              ...el, // Spread the existing styles
              height: `${theight}px`, // Set the new height
            });
          }
        }
        updateNodeInternals(el.id);
        return el;
      })
    );
    updateNodeInternals(cNode.id);
  };

  function checkAndProceedBranching(cNode, actionObj) {
    let haveDups = false;
    let existingDups = {};
    setNodes((els) => {
      let allnods = els.map((el) => {
        console.log(el);
        console.log(actionObj);

        if (
          cNode.id != el.id &&
          cNode.type === el.type && // Add type check here
          actionObj.value &&
          el.data &&
          el.data.selected_object &&
          actionObj.value.code * 1 == el.data.selected_object.code * 1
        ) {
          haveDups = true;
          existingDups.existingnode = actionObj.value;
        }
        return el;
      });
      if (haveDups) {
        setErrorNodes([cNode]);
        // Assuming the flag key value is set to 4
        props.onmsg("4", existingDups);
        if (cNode && cNode.data && cNode.data.selected_object_old) {
          performAction(cNode, {
            action: 3,
            value: JSON.parse(JSON.stringify(cNode.data.selected_object_old)),
          });
        } else {
          performAction(cNode, {
            action: 3,
            value: null,
          });
        }
      } else {
        setErrorNodes([]);
        loadBranching(cNode, actionObj);
      }
      return allnods;
    });
  }

  const performAction = (cNode, actionObj) => {
    console.log("performAction");
    setAsActive(null, cNode);
    switch (actionObj.action) {
      case -1:
        setNodes((nds) => {
          return nds.map((nd) => {
            /**
             * Sorting in order to show No Matches Handle at the end of the list
             */
            if (nd.type == "callerIdNode") {
              let temp_handles = nd.data.handles.sort((a, b) => {
                if (a.value === "minus1" && b.value !== "minus1") return 1;
                if (a.value !== "minus1" && b.value === "minus1") return -1;
                return 0;
              });
              cNode = { ...cNode, data: { ...cNode.data, handles: temp_handles } };
              return { ...nd, data: { ...nd.data, handles: temp_handles } };
            }
            if (nd.id === cNode.id) {
              setTimeout(() => {
                updateNodeInternals(nd.id);
              }, 500);
            }
            return nd;
          });
        });
        break;
      case 0:
        //autoResizeNode(cNode);
        break;
      case 1:
        setIsEdited(true);
        /***
         * Popups Events
         */
        switch (cNode.type) {
          case "scheduleNode":
            if (actionObj.value) {
              toggleEditSchedule(actionObj.value);
            } else {
              toggleNewSchedule();
            }
            break;
          case "huntNode":
            toggleNewHunt();
            break;
          case "callerIdNode":
            toggleCFilter();
            break;
          case "acdQueueNode":
            toggleNewACD();
            break;
          case "attendantNode":
            if (actionObj.value == "greeting") {
              setCurrentNode(getNodes().find((n) => n.id === cNode.id) ?? cNode);
              toggleCFilterEGreet();
              getAnnouncements(cNode?.data?.selected_object?.code);
            } else {
              toggleNewAA();
            }
            break;
          case "announcementNode":
            toggleCFilterEGreet();
            break;
          case "voicemailNode":
            toggleNewVMBox();
            break;
        }
        break;
      case 2: {
        /**
         * Handles Code
         */
        setIsEdited(true);
        let handles = getHandles(actionObj, cNode);
        cNode.data = { ...cNode.data, handles: handles };
        setNodes((nds) => {
          return nds.map((nd) => {
            if (nd.id === cNode.id) {
              setTimeout(() => {
                updateNodeInternals(nd.id);
              }, 500);
              return { ...nd, data: { ...nd.data, handles: handles } };
            }
            //updateNodeInternals(cNode.id);
            return nd;
          });
        });
        autoResizeNode(cNode);
        /** Added because the callerId node was not updating dynamically once a handle is deted and add a new node */
        if (cNode.type == "callerIdNode") {
          setTimeout(() => {
            onRNodeClick(null, cNode);
          }, 500);
        }
        break;
      }
      case 3:
        /**
         * Manage selected Object
         */
        setIsEdited(true);
        cNode.data = { ...cNode.data, selected_object: actionObj.value };
        setNodes((nds) => {
          return nds.map((nd) => {
            if (nd.id === cNode.id) {
              return {
                ...nd,
                data: { ...nd.data, selected_object: actionObj.value },
              };
            }
            return nd;
          });
        });
        break;
      case 4:
        /**
         * Direct handle update without reprocessing
         */
        setIsEdited(true); 
        cNode.data = { ...cNode.data, handles: actionObj.handles };
        setNodes((nds) => {
          return nds.map((nd) => {
            if (nd.id === cNode.id) {
              setTimeout(() => { 
                updateNodeInternals(nd.id);
              }, 500);
              return {
                ...nd,
                data: { ...nd.data, handles: actionObj.handles },
              };
            }
            return nd;
          });
        });
        autoResizeNode(cNode); 
        break;

      case 6: {
        cNode.iserror = true;
        setErrorNodes([cNode]);
        break;
      }
      case 7:
        if (
          cNode.type == "attendantNode" ||
          cNode.type == "huntNode" ||
          cNode.type == "scheduleNode"
        ) {
          checkAndProceedBranching(cNode, actionObj);
        }
        break;
      case 20:
        toggleEditFilter();
        setNodes((nds) => {
          return nds.map((nd) => {
            if (nd.id === cNode.id) {
              const editHId = actionObj.editHId;
              const specificHandle = nd.data.handles.find(
                (handle) => handle.id === editHId
              );
              setEditSpechandle(specificHandle);
            }
            return nd;
          });
        });

        break;

      case 15: {
        console.log(
          "111111111111222222222222223333333333334444444444444444444"
        );
        console.log(actionObj);
        setEdges((eds) => {
          console.log(eds);
          let tpedgs = eds.filter(
            (ten) => ten.sourceHandle + "" == actionObj.value + ""
          );
          let targetNodeIds = getAllSubNodeIds(cNode.id, tpedgs);
          console.log(targetNodeIds);
          if (targetNodeIds.length > 0) {
            const targetNodeId = targetNodeIds[0];
            // Check if target node has other incoming edges besides the one from this handle
            const otherIncomingEdges = eds.filter(
              (edge) => edge.target === targetNodeId && edge.sourceHandle + "" !== actionObj.value + ""
            );
            // Only delete the node if it has no other incoming connections
            if (otherIncomingEdges.length === 0) {
              onDeleteNode(targetNodeId, true);
            }
          }
          autoResizeNode(cNode);
          return eds;
        });
      }
        break;
      case 16: {
        console.log(actionObj.value);
        if (actionObj.value && actionObj.value.code) {
          getAnnouncements();
        } else {
          getAnnouncements();
        }
      }
        break;
      case 17: {
        props.onmsg("12", actionObj.value);
      }
    }
    //autoResizeNode(cNode);
    //updateNodeInternals(cNode.id);

    //props.onLoading("false");
  };
  const ignoreResizeObserverError = () => {
    const originalConsoleError = console.error;
    console.error = (...args) => {
      if (
        args[0]?.includes(
          "ResizeObserver loop completed with undelivered notifications"
        )
      ) {
        return;
      }
      originalConsoleError(...args);
    };
  };

  const getAllSubNodeIds = (nodeId, allEdges, selfflag) => {
    console.log(nodeId);
    console.log(allEdges);
    const directTargetEdges = allEdges.filter((edge) => edge.source === nodeId);
    const directTargetNodeIds = directTargetEdges.map(
      (edge) => edge.target + ""
    );

    console.log(directTargetNodeIds);
    if (directTargetNodeIds.length === 0) {
      console.log(selfflag);
      if (selfflag) {
        return [nodeId];
      } else {
        return [];
      }
    }

    const allSubNodeIds = [];
    directTargetNodeIds.forEach((targetNodeId) => {
      allSubNodeIds.push(targetNodeId);
      allSubNodeIds.push(...getAllSubNodeIds(targetNodeId, allEdges, selfflag));
    });

    console.log(allSubNodeIds);
    if (selfflag) {
      return [...allSubNodeIds, nodeId + ""];
    } else {
      return allSubNodeIds;
    }
  };
  const handleRemoveTargetNodes = (node, nodes, edges) => {
    console.log(edges);
    console.log(node);
    if (edges && edges.length > 0) {
      const outgoingEdges = edges.filter(
        (edge) => edge.source + "" === node.id + ""
      );
      const targetNodeIds = outgoingEdges.map((edge) => edge.target + "");
      console.log(targetNodeIds);
      console.log(node.id);
      nodeTargetsMap[node.id + ""] = targetNodeIds;
      console.log(nodeTargetsMap);
    }
  };

  // Function to get all target nodes for a given node ID
  const getTargetNodes1 = (nodeId, edges) => {
    return edges
      .filter((edge) => edge.source === nodeId) // Find edges where the current node is the source
      .map((edge) => edge.target); // Extract the target node IDs
  };

  // Function to delete target nodes
  const deleteTargetNodes1 = (nodeId, nodes, edges, setNodes, setEdges) => {
    // Update the state with the new nodes and edges
    console.log("dddddddddddddddddddddddddddddddddddddd----------------");
    console.log(nodeTargetsMap);
    console.log(nodeId);
    const targetNodeIds = nodeTargetsMap[nodeId + ""] || [];
    const targetEdgeIds = edgeTargetsMap[nodeId + ""] || [];

    setNodes((prevNodes) => {
      console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx----------------");
      console.log(targetNodeIds);
      // if (targetNodeIds[0]) {
      return prevNodes.filter((node) => !targetNodeIds.includes(node.id + ""));
      /*  } else {
        return prevNodes;
      }*/
    });

    setEdges((prevEdges) => {
      return prevEdges.filter((edge) => !targetEdgeIds.includes(edge.id + ""));
    });
  };

  function getSchudeNodeType(tndObj) {
    if (tndObj) {
      return tndObj.data.selected_object.schedule_type;
    } else {
      return 0;
    }
  }
  async function loadBranching(tndObj, dataObj) {
    props.showload("true");
    let type = 1;
    if (tndObj.type === "huntNode") {
      type = 2;
    }
    if (tndObj.type === "attendantNode") {
      type = 3;
    }
    /**
     * Deleting all existing connected nodes and edges
     * */
    onDeleteNode(tndObj.id, false);

    /**
     * Getting BranchInfo
     */
    const storedState = localStorage.getItem("callflowState");
    let parsedState = { call_flow_id: -1 };
    if (storedState) {
      parsedState = JSON.parse(storedState).callflow;
    }

    let reqInfo = {
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      node_type: type,
      entity_id:
        dataObj && dataObj.value
          ? dataObj.value?.code
          : tndObj.data.selected_object?.code,
      node_id: tndObj.id,
      position: tndObj.position,
      call_flow_id: parsedState.call_flow_id,
      entity_type: tndObj.data.selected_object?.schedule_type, // schedule_type
    };
    console.log(reqInfo);
    const apiResponse = await getBranchnodes(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      reqInfo
    );
    if (!apiResponse.json) {
      const message = `An error has occured: ${apiResponse.statusText}`;
      return;
    }
    let info = await apiResponse.json();
    console.log(info);
    props.showload(false);
    console.log("Branching info ::::::::::::::" + info);

    let thisnod = info.nodes.filter((node) => node.id + "" === tndObj.id + "");
    if (thisnod && thisnod.length > 0) {
      setNodes((nds) =>
        nds.map((n) =>
          n.id === tndObj.id + ""
            ? {
              ...n,
              style: {
                ...n.style,
                height: thisnod[0].style.height,
                minHeight: thisnod[0].style.minHeight,
              },
              data: {
                ...n.data,
                handles: thisnod[0].data.handles,
                ...(dataObj && 'greetingsData' in dataObj
                  ? { info: dataObj.greetingsData, greetinfo: dataObj.greetingsData }
                  : {}),
              },
            }
            : n
        )
      );
      autoResizeNode(thisnod[0]);
      updateNodeInternals(thisnod[0].id);
      setNodes((nds) =>
        nds.map((n) => {
          if (n.id === tndObj.id + "") {
            if (n.type === "attendantNode") {
              return {
                ...n,
                data: {
                  ...n.data,
                  operator_data: thisnod[0].data.operator_data,
                  directory_data: thisnod[0].data.directory_data,
                },
              };
             
            }
          }
          console.log("n dataa ::::;" , JSON.stringify(n))
          return n;
        })
      );
      
      
    }
    addNodes(registerAction(info.nodes.filter((nd) => nd.id !== tndObj.id)));
    setTimeout(() => {
      addEdges(info.edges);
      onRPanelClick(null);
    }, 500);
  }
  const addEdges = (newEdges) => {
    console.log(edges);
    console.log(newEdges);
    const uniqueNewEdges = newEdges.filter(
      (newEdge) =>
        !edges.some(
          (edge) => edge.id === newEdge.id && edge.target === newEdge.target
        )
    );

    if (uniqueNewEdges.length > 0) {
      uniqueNewEdges.map((eg, ind) => {
        try {
          console.log(ind);
          console.log(eg);

          setEdges((egs) => egs.concat(eg));
          console.log("-------------------------------------");
          updateNodeInternals(eg.target);
          updateNodeInternals(eg.source);
        } catch (e) { }
      });
      // setEdges((prevEdges) => [...prevEdges, ...uniqueNewEdges]);
    } else {
      console.log("No new unique edges to add");
    }
  };
  let prevId = {};
  const nodeTargetsMap = {};
  const edgeTargetsMap = {};
  const addUniqueNode = useCallback(
    (newNodes) => {
      const existingNodes = getNodes();
      // Filter out duplicates based on a specific property, e.g., 'id'

      const uniqueNodes = newNodes.filter((newNode) => {
        return !existingNodes.some(
          (existingNode) =>
            existingNode.data.selected_object.code &&
            newNode.data.selected_object.code &&
            existingNode.data.selected_object.code ===
            newNode.data.selected_object.code
        );
      });

      // Add only unique nodes
      console.log(uniqueNodes);
      if (uniqueNodes.length > 0) {
        setNodes((prevNodes) => [...prevNodes, ...uniqueNodes]);
      }
    },
    [setNodes, getNodes]
  );
  const addNodes = (newNodes, afterAddFunc) => {
    // Filter out nodes that already exist in the array based on the unique identifier 'id'
    const uniqueNewNodes = newNodes.filter(
      (newNode) => !nodes.some((node) => node.id === newNode.id)
    );

    // If there are unique nodes to add, update the nodes array
    if (uniqueNewNodes.length > 0) {
      setNodes((prevNodes) => [...prevNodes, ...uniqueNewNodes]);
    } else {
      console.log("No new unique nodes to add");
    }
    if (afterAddFunc) {
      afterAddFunc();
    }
  };

  const deleteHandle = (e, id, dataObj) => { };
  const registerAction = (nodes, edges) => {
    nodes.map((node) => {
      //handleRemoveTargetNodes(node, nodes, edges);
      try {
        node.data.actionExecutor = (taction) => {
          performAction(node, taction);
        };
        if (node.data.selected_object) {
          node.data.selected_object = {
            ...node.data.selected_object,
            isnew: false,
          };
        }

        node.handles = [];
        node.data.skipConfirmation = false;
        node.data.onDelete = () => {
          console.log("on delete");
          console.log(node.id);
          onDeleteNode(node.id, true);
        };
      } catch (e) { }
    });
    return nodes;
  };

  const loadVisualEditor = (e, obj) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (isEdited || !canUndo) {
      setSelFlow(obj);
      toggleWarning();
    } else {
      const state = {
        callflow: obj,
        callflow_list:
          localStorage.getItem("callflowState") &&
          JSON.parse(localStorage.getItem("callflowState")) &&
          JSON.parse(localStorage.getItem("callflowState")).callflow_list.sort(
            (a, b) => a?.name?.localeCompare(b?.name)
          ),
      };
      localStorage.setItem("callflowState", JSON.stringify(state));
      localStorage.setItem("veditor_cfid", JSON.stringify(obj));
      window.location.reload();
    }
  };

  const onNodeClick = useCallback(
    (event, type, tnodes) => {
      event.preventDefault();

      if (typeof type === "undefined" || !type) {
        return;
      }
      const { clientWidth, clientHeight } = reactFlowWrapper.current;

      const position = reactFlowInstance.screenToFlowPosition({
        x: 630 + tnodes.length * 10,
        y: clientHeight / 4 - 200 + tnodes.length * 10,
      });

      /**Create New Node here */
    },
    [reactFlowInstance]
  );

  const createCFNode = (type, position, donottrack, id, skipConfirmation) => {
    try {
      let cfnid = id ? id : new Date().getTime() + "";
      const cfNode = JSON.parse(JSON.stringify(cfNodesLib[type]));
      cfNode.id = cfnid;
      cfNode.position = position;
      cfNode.data.showAnalyticsLabel = false;
      cfNode.data.skipConfirmation = skipConfirmation ? "true" : false;

      if (cfNode.handles) {
        cfNode.data.hdata = {};
        cfNode.data.hdata.handles = cfNode.handles;
      }
      cfNode.data.cfid = callflow.call_flow_id;
      cfNode.data.resize = (tsize) => {
        cfNode.style.height = tsize;
      };
      cfNode.data.actionExecutor = (taction) => {
        performAction(cfNode, taction);
      };
      cfNode.data.onDelete = () => {
        onDeleteNode(cfNode.id, true);
      };
      setNodes((nds) => nds.concat(cfNode));
      if (donottrack != 1) {
        takeSnapshot();
      }
      setAsActive(null, cfNode);
      return cfnid;
    } catch (e) { }
  };
  const onDrop = useCallback(
    (event) => {
      event.preventDefault();
      const type = event.dataTransfer.getData("application/reactflow");
      if (typeof type === "undefined" || !type) {
        return;
      }
      const { clientWidth, clientHeight } = reactFlowWrapper.current;

      const position = reactFlowInstance.screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      });
      createCFNode(type, position);
    },
    [reactFlowInstance]
  );

  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.effectAllowed = "move";
    //takeSnapshot();
  };

  const onElementsRemove = (elementsToRemove) => {
    setNodes((els) => els.filter((el) => !elementsToRemove.includes(el)));
    // setEdges((els) => els.filter((el) => !elementsToRemove.includes(el)));
  };

  const getTargetNodes = (source, tlevel) => {
    const treges = edges
      .filter((edg) => edg.source == source)
      .sort((a, b) => a.sourceHandle - b.sourceHandle);

    const { clientWidth, clientHeight } = reactFlowWrapper.current;
    const verticalSpacing = (clientHeight - 50 * 3) / 4; // 3 nodes with 4 spacings

    const trnodes = [];
    if (treges.length > 0) {
      treges.map((te, index) => {
        let cnode = nodes.filter((nod) => te.target === nod.id)[0];

        trnodes.push({
          ...cnode,
          position: {
            x: 300 * tlevel,
            y: verticalSpacing * (index + 1) + 200 * index,
          },
        });
      });
    }

    return trnodes;
  };
  const alignNodesHorizontally = () => {
    // Find the root node (a node without incoming edges)

    const rootNode = nodes.find(
      (node) => !edges.find((edge) => edge.target === node.id)
    );

    if (rootNode) {
      // Initialize positions for the root node
      const { clientWidth, clientHeight } = reactFlowWrapper.current;
      rootNode.position = { x: 0, y: clientHeight / 2 - 200 };

      // Function to recursively set positions for children nodes
      const setChildPositions = (parentNode, depth) => {
        const children = edges
          .filter((edge) => edge.source === parentNode.id)
          .map((edge) => nodes.find((node) => node.id === edge.target));

        children.forEach((child, index) => {
          child.position = {
            x: parentNode.position.x + depth * 1 + 400, // Adjust the horizontal spacing here
            y: parentNode.position.y - index * 200 + 400, // Adjust the vertical spacing here
          };
          setChildPositions(child, depth + 1);
        });
      };

      // Start setting positions recursively from the root node
      setChildPositions(rootNode, 1);
    }

    // let trgtnodes1 = [];
    // trgtnodes.map((nd) => {
    //   trgtnodes1 = getTargetNodes(nd, 2);
    //   setNodes([...nodes, trgtnodes1]);
    // });

    // console.log(trgtnodes);
    let tcolum = 1;

    // const nodeSourceCounts = {};
    // nodes.forEach((node) => {
    //   if (!node.source) {
    //     nodeSourceCounts[node.id] = 0;
    //   }
    // });
    // nodes.forEach((node) => {
    //   if (
    //     node.source &&
    //     node.target &&
    //     nodeSourceCounts[node.target] !== undefined
    //   ) {
    //     nodeSourceCounts[node.target]++;
    //   }
    // });

    // // Sort nodes based on the number of source edges/handles
    // const sortedNodes = [...nodes].sort((a, b) => {
    //   const countA = nodeSourceCounts[a.id] || 0;
    //   const countB = nodeSourceCounts[b.id] || 0;
    //   return countA - countB;
    // });

    // // Update node positions horizontally
    // const horizontalGap = 200; // Adjust this value as needed
    // let currentX = 100; // Initial x position
    // const updatedNodes = sortedNodes.map((node, index) => {
    //   const newPosition = { ...node.position, x: currentX };
    //   currentX += horizontalGap; // Move to the next position
    //   return { ...node, position: newPosition };
    // });
    // setNodes(updatedNodes);
    // // Update state with new positions

    // // Update positions
  };

  const sortNodesByEdgeFlow = (edgeMap) => {
    const visited = new Set();
    const result = [];

    const dfs = (node) => {
      if (visited.has(node)) return;
      visited.add(node);
      const edges = edgeMap.get(node) || [];
      edges.forEach((neighbor) => dfs(neighbor));
      result.push(node);
    };

    edgeMap.forEach((_value, node) => {
      if (!visited.has(node)) dfs(node);
    });

    return result.reverse();
  };
  const onConnect = useCallback(
   
    (params, existingEdges) => {
      takeSnapshot(); 
      const { source, sourceHandle, target, targetHandle, type } = params;
      const isValid = sourceHandle && targetHandle;

      if (source === target) {
        props.onmsg("18");
        return; // Exit early, don't add the edge
      }
      if (isValid) {
        const existingEdge = existingEdges.find(
          (element) =>
            element.sourceHandle === sourceHandle &&
            element.source === source &&
            element.target !== target
        );

        if (existingEdge) {
          const updatedEdge = { ...existingEdge, targetHandle, target };
          const updatedElements = existingEdges.map((element) =>
            element.id === updatedEdge.id ? updatedEdge : element
          );
          setEdges(updatedElements);
        } else {
          setEdges((els) => addEdge(params, els));
        }
        setNodes((nds) => {
          nds.forEach((node) => {
            if (node.id === source) {
              setAsActive({}, nds);
            }
          });
          return [...nds]; // Spread the array instead of directly returning it
        }); 

        setNodes((nds) =>
          nds.map((nd) => {
            if (nd.id === target && (nd.type === "directoryNode" || nd.type === "operatorNode")) {
              const sourceNode = nds.find((n) => n.id === source);
              if (sourceNode?.type === "attendantNode") {
                const selected_object =
                  nd.type === "directoryNode"
                    ? sourceNode.data.directory_data
                    : sourceNode.data.operator_data;
                const updatedNode = {
                  ...nd,
                  data: {
                    ...nd.data,
                    selected_object,
                  },
                };
        
                setTimeout(() => updateNodeInternals(updatedNode.id), 0);
                return updatedNode;
              }
            }
            console.log(" updated nd :::" , JSON.stringify(nd))
            return nd;
          })
        );

      }
    },
    [setEdges, takeSnapshot]
  );
  const edgeUpdateSuccessful = useRef(true);
  const onReconnectStart = useCallback(() => {
    edgeUpdateSuccessful.current = false;
  }, []);

  const onReconnect = useCallback((oldEdge, newConnection) => {
    takeSnapshot();
    edgeUpdateSuccessful.current = true;
    setEdges((els) => reconnectEdge(oldEdge, newConnection, els));
  }, []);

  const onReconnectEnd = useCallback((_, edge) => {
    if (!edge) {
      return;
    }
    takeSnapshot();
    if (!edgeUpdateSuccessful.current) {
      setEdges((eds) => eds.filter((e) => e.id !== edge.id));
    }

    edgeUpdateSuccessful.current = true;
  }, []);
  function refreshClick() {
    if (canUndo) {
      window.location.reload();
    } else {
      togglerefresh();
    }
  }
  function goBacktoCFL(flg, obj) {
    if (flg === "ref") {
      window.location.reload();
      togglerefresh();
      return;
    }

    if (flg === 1) {
      if (window.opener) {
        window.opener.location.reload();
      }
      // navigate("/callflowlanding");
      window.close();
      return;
    }

    if (flg === 2) {
      localStorage.setItem("veditor_cfid", JSON.stringify(obj));
      window.location.reload();
      return;
    }
    if (isEdited || !canUndo) {
      toggleWarning();
    } else {
      // navigate("/callflowlanding");
      window.close();
    }
  }
  let hedges = [];
  const highlightConnectedEdges = (medge) => {
    hedges.push(medge.id);
    const newElements = edges.map((el) => {
      if (hedges.includes(el.id)) {
        return {
          ...el,
          markerEnd: {
            ...el.markerEnd,
            color: "#009D8D",
          },
          style: {
            ...el.style,
            stroke: "#009D8D",
          },
          animated: true,
        };
      } else {
        return {
          ...el,
          markerEnd: {
            ...el.markerEnd,
            color: color,
          },
          style: {
            ...el.style,
            stroke: color,
          },
          animated: false,
        };
      }
    });
    setEdges(newElements);
    const connectedEdges = edges.filter((el) => el.source === medge.target);
    if (connectedEdges && connectedEdges.length > 0) {
      connectedEdges.map((el) => {
        highlightConnectedEdges(el);
      });
    }
  };

  const onEdgeClick = (event, edge) => {
    hedges = [];
    highlightConnectedEdges(edge);
  };

  const onNodeDragStop = () => {
    try {
      setNodes((nds) =>
        nds.map((node) => {
          return {
            ...node,
            style: {
              ...node.style,
              border: cfNodesLib[node.type]
                ? cfNodesLib[node.type].style.border
                : "2px solid green",
            },
          };
        })
      );
      setEdges((eds) =>
        eds.map((edge) => ({
          ...edge,
          style: { ...edge.style, stroke: color, strokeWidth: 1 }, // Reset edge style
          markerEnd: { ...edge.markerEnd, color: color },
          animated: false,
        }))
      );
    } catch (e) { }
    // takeSnapshot();
  };

  const onNodeMDragStop = (node) => {
    try {
      updateNodeBack();
      updateNodeInternals(node.id);
      setEdges((eds) =>
        eds.map((edge) => ({
          ...edge,
          style: { ...edge.style, stroke: color, strokeWidth: 1 }, // Reset edge style
          markerEnd: { ...edge.markerEnd, color: color },
          animated: false,
        }))
      );
    } catch (e) { }
    //takeSnapshot();
  };

  // class ResizeObserverMock {
  //   observe() {}
  //   unobserve() {}
  //   disconnect() {}
  // }
  // window.ResizeObserver = ResizeObserverMock;

  const onRNodeClick = (_, node) => {
    setNodes((nds) =>
      nds.map((n) =>
        n.id === node.id && node.type !== "scheduleNode"
          ? {
            ...n,
            style: { ...n.style, border: "2px solid brown" },
            active: true,
            selected: true,
          }
          : {
            ...n,
            style: {
              ...n.style,
              border: cfNodesLib[n.type]
                ? cfNodesLib[n.type].style.border
                : "2px solid green",
            },
            active: false,
            selected: false,
          }
      )
    );
    setAsActive(null, node);
    takeSnapshot();
  };
  const onRPanelClick = (node) => {
    setNodes((nds) =>
      nds.map((n) =>
        n.active === true
          ? {
            ...n,
            style: {
              ...n.style,
              border: cfNodesLib[n.type]
                ? cfNodesLib[n.type].style.border
                : "2px solid green",
            },
            active: false,
            selected: false,
          }
          : n
      )
    );
    //   takeSnapshot();
  };

  const onNodeDrag = (_, node) => {
    const connectedEdges = edges.filter(
      (edge) => edge.source === node.id || edge.target === node.id
    );

    bringEdgeFront(connectedEdges)

    // Highlight the node being dragged
    setNodes((nds) =>
      nds.map((n) =>
        n.id === node.id
          ? {
            ...n,
            style: { ...n.style, border: "2px solid #fd7e14" },
          } //  node.style = { ...node.style, border: "2px solid brown" };Highlighted node style
          : n
      )
    );

    // Highlight connected edges while dragging
    setEdges((eds) =>
      eds.map((edge) =>
        connectedEdges.includes(edge)
          ? {
            ...edge,
            style: { stroke: "#fd7e14", strokeWidth: 5 },
            markerEnd: { ...edge.markerEnd, color: "#fd7e14" },
          } // Highlighted edge style
          : edge
      )
    );
  };

  const onSelectionDragStart = useCallback(() => {
    // 👇 make dragging a selection undoable
    takeSnapshot();
  }, [takeSnapshot]);

  const onNodesDelete = useCallback(
    (deleted) => {
      setEdges(
        deleted.reduce((acc, node) => {
          const incomers = getIncomers(node, nodes, edges);
          const outgoers = getOutgoers(node, nodes, edges);
          const connectedEdges = getConnectedEdges([node], edges);

          const remainingEdges = acc.filter(
            (edge) => !connectedEdges.includes(edge)
          );

          const createdEdges = incomers.flatMap(({ id: source }) =>
            outgoers.map(({ id: target }) => ({
              id: `${source}->${target}`,
              source,
              target,
            }))
          );

          return [...remainingEdges, ...createdEdges];
        }, edges)
      );
    },
    [nodes, edges]
  );

  const [draggingNodeId, setDraggingNodeId] = useState(null);
  const onNodeDragStart = (_, node) => {
    setDraggingNodeId(node.id);
    takeSnapshot();
  };

  const setAsActive = (event, node) => {
    setSelectedNodes([node]);
    setCurrentNode(node);
  };

  const updateNode = (nodeId) => {
    setNodes((nds) =>
      nds.map((n) => {
        if (n.id === nodeId && n.active !== true) {
          return {
            ...n,
            style: { ...n.style, border: "2px solid #fd7e14" },
            markerEnd: n.markerEnd
              ? { ...n.markerEnd, color: "#fd7e14" }
              : { color: "#fd7e14" },
          };
        }
        return n;
      })
    );
    //updateNodeInternals(nodeId);
  };

  const updateNodeBack = () => {
    setNodes((nds) =>
      nds.map((n) => {
        if (n.active === true) {
          return n;
        } else {
          return {
            ...n,
            style: {
              ...n.style,
              border: cfNodesLib[n.type]
                ? cfNodesLib[n.type].style.border
                : "2px solid green",
            },
            markerEnd: n.markerEnd
              ? { ...n.markerEnd, color: "#fd7e14" }
              : { color: "#fd7e14" },
          };
        }
      })
    );
  };

   const bringEdgeFront = (connectedEdges) => {
  const edgesContainer = document.querySelector(".react-flow__edges");
  if (!edgesContainer) return;

  const sElements = edgesContainer.querySelectorAll("svg");  
  const edgeNodeIds = new Set();
  connectedEdges.forEach(({ source, target }) => {
    edgeNodeIds.add(source);
    edgeNodeIds.add(target);
  });

  sElements.forEach((sEl) => {
    const hasMatchingChild = Array.from(sEl.children).some((child) => {
      const dataId = child.dataset.id || '';
      return [...edgeNodeIds].some(id => dataId.includes(id));
    });

    sEl.style.zIndex = hasMatchingChild ? 999 : 0;
  });
};

   const sendTOBack= () => {
      const edgesContainer = document.querySelector(".react-flow__edges");
      if (edgesContainer) {
        const sElements = edgesContainer.querySelectorAll("svg");
        sElements.forEach((sEl) => {          
            sEl.style.zIndex = 0;
        });
      }
  }

  const onNodeMouseLeave = (node) => {
    try {
      updateNodeBack();
      updateNodeInternals(node.id);
      setEdges((eds) =>
        eds.map((edge) => ({
          ...edge,
          style: { ...edge.style, stroke: color, strokeWidth: 1 }, // Reset edge style
          markerEnd: { ...edge.markerEnd, color: color },
          animated: false,
        }))
      );
      sendTOBack()
    } catch (e) { }
  };
  const onNodeMouseEnter = useCallback((event, node) => {
    event.preventDefault();
    ignoreResizeObserverError();
    try {
      const connectedEdges = edges.filter((edge) => edge.target === node.id);
      bringEdgeFront(connectedEdges)
      updateNode(node.id);
      setTimeout(() => {
        setEdges((eds) =>
          eds.map((edge) =>
            connectedEdges.includes(edge)
              ? {
                ...edge,
                style: { stroke: "#fd7e14", strokeWidth: 5 },
                markerEnd: { ...edge.markerEnd, color: "#fd7e14" },
              } // Highlighted edge style
              : edge
          )
        );
      }, 0); // Highlight connected edges while dragging
    } catch (e) { }
  });
  /**************************************************************************************** */

  useEffect(() => {
    setNodes([
      ...nodes.map((node) => ({
        ...node,
        position: nodeComponents[node.id]
          ? nodeComponents[node.id]
          : { x: 100, y: 100 },
      })),
    ]);
  }, [nodeComponents, setNodes]);

  useEffect(() => {
    setNodes((nds) =>
      nds.map((n) => {
        if (n.type == "notes") {
          return {
            ...n,
            hidden: hidden,
          };
        } else {
          return {
            ...n,
          };
        }
      })
    );
  }, [hidden]);

  useEffect(() => {
    setNodes((nds) =>
      nds.map((node) => {
        try {
          let enodeA = errorNodes.filter((enode) => enode.id == node.id);
          if (enodeA.length > 0) {
            return {
              ...node, // Spread existing node properties
              style: {
                ...node.style, // Spread existing style properties
                border: "2px solid RED", // Update border style
              },
            };
          }
          return { ...node }; // Return a shallow copy of the node if no error
        } catch (e) {
          console.error(e); // Optional: log the error if something goes wrong
          return { ...node }; // Return a shallow copy of the node in case of an error
        }
      })
    );
  }, [errorNodes, setNodes]);

  useEffect(() => {
    document.title = "Call Flow";
  }, []);

  /*************************************************************************************************************** */

  async function getAnnouncements(id) {
    let reqJSON = {};
    if (id) {
      // Auto attendant Node
      reqJSON = {
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        greeting_type: 4,
        id: id,
      };
    } else {
      reqJSON = {
        // Annoucment Node
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        greeting_type: 5,
      };
    }
    const apiResponse = await getExistingGreetingsInfo(reqJSON);

    if (!apiResponse.json) {
      const message = `An error has occured: ${apiResponse.statusText}`;
      return;
    }
    let info = await apiResponse.json();
    console.log("Existing Greetings");
    console.log(info);
    setExistingGreetings(info);
  }

  async function getNodesEdges1(cNode, dataObj, id) {
    setNodes((els) => {
      return els.map((el) => {
        if (el.id === cNode.id) {
          loadBranching(el, dataObj);
        }
        return el;
      });
    });
  }
  const [nodesReady, setNodesReady] = useState(false); // Tracks when nodes are ready
  const [pEdges, setPEdges] = useState([]);
  const [disablesave, setdisablesave] = useState(false)
  const [locationTZ, setlocationTZ] = useState(0);
  /**
   * Getting Nodes and Edges saved in Database
   * @param {getNodesEdges} id
   * @returns
   */
  async function getNodesEdges(id) {
    props.showload(true);
    const response = await getSpecificCallFlows(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      id
    );

    if (!response.json) {
      return;
    }
    const rawData = await response.json();

    console.log("rawData***************", rawData);
    if (!rawData) {
      window.alert(`info with id not found`);
      navigate("/");
    }
    const { clientHeight } = reactFlowWrapper.current;
    const uEdges = (
      rawData.edges && rawData.edges.edg ? rawData.edges.edg : []
    ).filter(
      (edge, index, self) => self.findIndex((n) => n.id === edge.id) === index
    );
    setlocationTZ(rawData?.loctimezone)
    const flowEdges = uEdges.map((el) => {
      return {
        ...el,
        markerEnd: {
          ...el.markerEnd,
          color: color,
        },
        style: {
          ...el.style,
          stroke: color,
        },
        animated: false,
      };
    });

    if (!rawData.nodes || !rawData.nodes.nod || rawData.nodes.nod.length <= 0) {
      createCFNode(
        "notes",
        {
          x: 2,
          y: clientHeight / 2 - 200 - 250,
        },
        1,
        "notes"
      );
      createCFNode(
        "scheduleNode",
        {
          x: 2,
          y: clientHeight / 2 - 200,
        },
        1,
        "scheduleNode",
        true
      );
    } else {
      const tPnodes = registerAction(rawData.nodes.nod);
      tPnodes.map((echnode, index) => {
        if (echnode?.type == "notes") {
          setNodes((prev) => [...prev, { ...echnode, hidden: false }]);
        } else {
          setNodes((prev) => [...prev, echnode]);
        }
        if (index === tPnodes.length - 1) {
          setNodesReady(true);
        }
      });
    }
    setPEdges(flowEdges);
    props.showload(false);
    setOnloadAligned(true);
  }
  useEffect(() => {
    setEdges(pEdges);
  }, [nodesReady]);

//   useEffect(() => {
//     if (onloadAligned) {
//       return;
//     }
//     setTimeout(() => {
//       const { nodes: layoutedNodes } = alignNodesWithDagLayout(
//         nodes,
//         edges,
//         "LR"
//       );
//       setNodes(layoutedNodes);
//       setEdges(edges);
//       setOnloadAligned(true);
//       setViewport({
//         x: 0, // Initial x position
//         y: 0, // Initial y position   
//         zoom: 1, // Initial zoom level
//       });
//       props.showload(false);
//     }, 2000);
//   }, [nodes, edges, nodesReady, setViewport]);
 const [onloadAligned, setOnloadAligned] = useState(false);

  useEffect(() => {
    try {
      window.addEventListener("message", (event) => {
        if (event.data?.type === "CHECK_URL") {
          if (window.location.href.includes("ai-call-flow")) {
            event.source.postMessage({ type: "URL_OK" }, "*");
          }
        }
        if (event.data?.type === "INVOKE_METHOD") {
          setSelFlow(event.data.data.veditor_cfid);
          console.log(
            "----------------------------------------------------------"
          );
          console.log(localStorage.getItem("callflowState_old"));
          console.log(localStorage.getItem("veditor_cfid_old"));
          localStorage.setItem(
            "callflowState",
            localStorage.getItem("callflowState_old")
          );
          localStorage.setItem(
            "veditor_cfid",
            localStorage.getItem("veditor_cfid_old")
          );
          toggleWarning();
        }
      });

      const storedState = localStorage.getItem("callflowState");
      if (storedState) {
        let parsedState = JSON.parse(storedState).callflow;
        if (localStorage.getItem("veditor_cfid")) {
          parsedState = JSON.parse(localStorage.getItem("veditor_cfid"));
          // setTimeout(() => {
          //   localStorage.removeItem("veditor_cfid");
          // }, 2000);
        }

        setCallflow(parsedState);
        getNodesEdges(parsedState.call_flow_id);
      } else {
        navigate("/callflowlanding");
      }
    } catch (error) {
      navigate("/callflowlanding");
    }
  }, []);

  // const hasAutoFitted = useRef(false);

  // useEffect(() => {
  //   if (reactFlowInstance && onloadAligned && nodes.length > 0 && !hasAutoFitted.current) {
  //     setTimeout(() => {
  //       reactFlowInstance.fitView({ padding: 0.1, duration: 800 });
  //       hasAutoFitted.current = true; // Mark as completed
  //     }, 100);
  //   }
  // }, [reactFlowInstance, onloadAligned, nodes.length]);

  const valid = () => {
    /**Validate Nodes*/
    /**Validate Schedule Node*/

    let notValidNodes = [];
    setErrorNodes([]);

    let sFilterEdges = [];
    edges.map((edg) => {
      let isconnExists =
        nodes.filter((nd) => nd.id + "" === edg.target + "").length > 0 &&
        nodes.filter((nd) => nd.id + "" === edg.source + "").length > 0;

      if (isconnExists) {
        sFilterEdges.push(edg);
      }
    });

    // setEdges(sFilterEdges);

    let shNode = nodes.map((vnode) => {
      let isValid = true;

      if (vnode.type !== "notes" && vnode.type !== "endCallNode") {
        if (vnode.type !== "notes" && vnode.type !== "endCallNode") {
          if (
            vnode.type !== "scheduleNode" &&
            !sFilterEdges.some((edge) => edge.target === vnode.id)
          ) {
            vnode.error = "No Target edge";
            notValidNodes.push(vnode);
          }
          if (vnode.type === "huntNode") {
            let iconnExists = sFilterEdges.filter(
              (vedge) =>
                (vedge.source === vnode.id && vedge.sourceHandle * 1 == 1) ||
                vedge.sourceHandle * 1 == 0
            );
            console.log(iconnExists);
            if (iconnExists.length == 0) {
              vnode.error = "No closing edge";
              notValidNodes.push(vnode);
            }
            if (!vnode.data.selected_object) {
              vnode.error = "No Object Selected";
              notValidNodes.push(vnode);
            }
          }
          if (vnode.type === "attendantNode") {
            let thandels = vnode.data.handles;
            console.log(thandels);
            console.log(sFilterEdges);
            if (thandels instanceof Array) {
              thandels.map((thandle, vindex) => {
                let iconnExists = sFilterEdges.filter(
                  (vedge) =>
                    vedge.source === vnode.id &&
                    vedge.sourceHandle + "" == thandle.id + ""
                );
                console.log(iconnExists);
                if (iconnExists.length == 0) {
                  vnode.error = "No closing edge";
                  notValidNodes.push(vnode);
                }
              });
            }
            if (
              !vnode.data.selected_object ||
              !vnode.data.selected_object.code
            ) {
              vnode.error = "No Object Selected";
              notValidNodes.push(vnode);
            }
          }
          if (
            vnode.type === "scheduleNode" ||
            vnode.type === "callerIdNode" ||
            vnode.type === "externalNumberNode"
          ) {
            console.log("----------------=====================");
            let thandels = vnode.data.handles;
            console.log(thandels);
            console.log(sFilterEdges);
            if (thandels instanceof Array) {
              thandels.map((thandle) => {
                let iconnExists = sFilterEdges.filter(
                  (vedge) =>
                    vedge.source === vnode.id &&
                    vedge.sourceHandle + "" == thandle.id + ""
                );
                console.log(iconnExists);
                if (iconnExists.length == 0) {
                  vnode.error = "No closing edge";
                  notValidNodes.push(vnode);
                }
              });
            }
            if (vnode.type === "scheduleNode") {
              if (
                !vnode.data.selected_object ||
                !vnode.data.selected_object.code
              ) {
                vnode.error = "No Object Selected";
                notValidNodes.push(vnode);
              }
            }
            if (vnode.type === "externalNumberNode") {
              if (
                vnode.data &&
                (!vnode.data.selected_object ||
                  !vnode.data.selected_object.title ||
                  vnode.data.selected_object.title == "")
              ) {
                vnode.error = "No Object Selected";
                notValidNodes.push(vnode);
              } else {
                if (vnode.data.selected_object.title.length <= 5) {
                  if (!/^(\+1|1)?[2-9]\d{2}[2-9]\d{6}$/.test(vnode.data.selected_object.title)) {
                    notValidNodes.push(vnode);
                  }
                } else if (
                  vnode.data.selected_object.title.length > 5 &&
                  vnode.data.selected_object.title.length < 10
                ) {
                  notValidNodes.push(vnode);
                }
              }
            }
          }
          if (
            vnode.type === "voicemailNode" ||
            vnode.type === "userExtensionNode"
          ) {
            if (
              !vnode.data.selected_object ||
              !vnode.data.selected_object.code
            ) {
              vnode.error = "No Object Selected";
              notValidNodes.push(vnode);
            }
          }
          if (vnode.type === "announcementNode") {
            if (
              !vnode.data.selected_object ||
              vnode.data.selected_object.code === undefined ||
              vnode.data.selected_object.code === null
            ) {
              vnode.error = "No Object Selected";
              notValidNodes.push(vnode);
            }
          }
          if (vnode.type !== "scheduleNode" && vnode.type === "notes") {
            let iconnExists = sFilterEdges.filter(
              (vedge) =>
                vedge.target === vnode.id && vedge.targetHandle == "target"
            );
            console.log(iconnExists);
            if (iconnExists.length == 0) {
              vnode.error = "No closing edge";
              notValidNodes.push(vnode);
            }
          }
          if (vnode.type == "operatorNode" || vnode.type === "directoryNode") {
            console.log("current all node :::::" , nodes);
            console.log("current all edges  :::::" , edges)
            const result = isConnectedOnlyFromNonAttendants(vnode.id, nodes, edges);
            console.log( " Connected result resulttttt::::::" , result);
            if (result) {
              vnode.error = "Invalid Connection: A Directory node only can be linked to an Auto Attendant node.";
              notValidNodes.push(vnode);
              errorNodes.push(vnode);
            } else if (
              !vnode.data.selected_object ||
              !vnode.data.selected_object.code
            ) {
              vnode.error = "The red highlighted nodes are experiencing errors because they either lack destination nodes or destination objects. Please correct them in order to proceed further and save";
              notValidNodes.push(vnode);
            }
          }
        }
      }
    });
    console.log(notValidNodes);
    setErrorNodes(notValidNodes);
    return notValidNodes.length == 0;
  };




  function isConnectedOnlyFromNonAttendants(targetId, nodes, edges) {
    const incomingEdges = edges.filter(edge => edge.target === targetId);
    console.log(` Checking incomingEdges of ${targetId}:`, incomingEdges.map(e => e.source));
  
    for (const edge of incomingEdges) {
      const sourceNode = nodes.find(n => n.id === edge.source);
      if (!sourceNode) continue;
  
      console.log(`Source: ${sourceNode.id}, type: ${sourceNode.type}`);
  
      if (sourceNode.type !== 'attendantNode') {
        console.log(` Found non-attendant node: ${sourceNode.id}`);
        return true;
      }
    }
  
    return false; 
  }
  
  
  
  const removeInvalidKeys = (obj) => {
    if (typeof obj !== "object" || obj === null) {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => removeInvalidKeys(item));
    }

    return Object.keys(obj).reduce((acc, key) => {
      if (
        typeof key === "string" &&
        (key === "children" || key.startsWith("$$") || key.startsWith("$"))
      ) {
        return acc;
      }

      const value = removeInvalidKeys(obj[key]);
      if (typeof value !== "undefined") {
        acc[key] = value;
      }

      return acc;
    }, {});
  };

  // Function to remove duplicate nodes based on id
  const removeDuplicateNodes = (nodes) => {
    const seenIds = new Set();
    return nodes.filter((node) => {
      if (seenIds.has(node.id)) {
        return false;
      } else {
        seenIds.add(node.id);
        return true;
      }
    });
  };

  const saveAsDraft = () => {
    save(null, 1);
  };
  const saveAsDrafWithNomessage = (temp_node) => {
    save(null, 1, 1, temp_node);
  };
  function findHuntNodeEdgesWithoutTarget(nodes, edges) {
    const huntNodeIds = nodes.nod
      .filter((node) => node.type === "huntNode")
      .map((node) => node.id);
    const huntNodesWithNoTarget = huntNodeIds.filter((huntNodeId) => {
      return !edges.edg.some(
        (edge) => edge.source === huntNodeId && edge.target
      );
    });
    return huntNodesWithNoTarget;
  }
  
  function findDuplicateNodesWithDifferentTargets(nodes, edges) {
    const targetNodeTypes = ["huntNode", "attendantNode", "ACDNode"];

    // Build a lookup: nodeId -> logical identity key ("type|code")
    // This lets us resolve any target node to its logical identity
    // so that two nodes with different IDs but same type+code are treated as the same
    const nodeIdentityMap = {};
    nodes.nod.forEach((node) => {
      const code = node.data?.selected_object?.code;
      if (code != null) {
        nodeIdentityMap[node.id] = `${node.type}|${code}`;
      } else {
        // Nodes with no selected object fall back to their unique id
        nodeIdentityMap[node.id] = `id|${node.id}`;
      }
    });

    // Filter only the node types we care about
    const relevantNodes = nodes.nod.filter((node) =>
      targetNodeTypes.includes(node.type)
    );

    // Group nodes by logical identity: "nodeType|code"
    const nodeGroupMap = {};
    relevantNodes.forEach((node) => {
      const code = node.data?.selected_object?.code;
      if (code == null) return;

      const key = `${node.type}|${code}`;
      if (!nodeGroupMap[key]) {
        const label =
          node.data.selected_object?.title ||
          node.data.selected_object?.label ||
          node.data.label ||
          "Unknown";
        nodeGroupMap[key] = {
          nodeIds: [],
          nodeName: label,
          nodeType: node.type,
        };
      }
      nodeGroupMap[key].nodeIds.push(node.id);
    });

    // For each logical group with multiple instances, check if they point to
    // different logical destinations (resolved by type+code, not raw node id)
    for (const key of Object.keys(nodeGroupMap)) {
      const group = nodeGroupMap[key];
      if (group.nodeIds.length < 2) continue;

      // For each instance, collect its outgoing targets resolved to logical identities
      // e.g. "voicemailNode|6537" instead of a raw UUID
      // This means two physically different nodes that represent the same entity
      // will produce the same identity string and be treated as equivalent targets
      const instanceTargets = group.nodeIds.map((nodeId) => {
        return edges.edg
          .filter((edge) => edge.source === nodeId)
          .map((edge) => nodeIdentityMap[edge.target] ?? `id|${edge.target}`)
          .sort()
          .join(",");
      });

      const uniqueTargetSets = new Set(instanceTargets);
      if (uniqueTargetSets.size > 1) {
        const nodeTypeLabel =
          group.nodeType === "huntNode"
            ? "Hunt"
            : group.nodeType === "ACDNode"
              ? "ACD"
              : "Auto Attendant";
        return {
          hasError: true,
          nodeName: group.nodeName,
          nodeTypeLabel,
        };
      }
    }

    return { hasError: false };
  }
 

  function findeExternalnumberTarget(nodes, edges) {
    const extNodeIds = nodes.nod
      .filter((node) => node.type === "externalNumberNode")
      .map((node) => node.id);
    const count = edges.edg.filter((edge) => {
      return (
        extNodeIds.includes(edge.source) && extNodeIds.includes(edge.target)
      );
    }).length;
    return count;
  }

  function findOperatorDirectorySources(nodes, edges) {
    // Step 1: Collect operatorNode and directoryNode IDs
    const targetNodeIds = nodes.nod
      .filter(node => node.type === "operatorNode" || node.type === "directoryNode")
      .map(node => node.id);
  
    // Step 2: Map of targetId -> array of unique sourceIds
    const targetSourceMap = {};
  
    edges.edg.forEach(edge => {
      const { target, source } = edge;
  
      if (targetNodeIds.includes(target)) {
        if (!targetSourceMap[target]) {
          targetSourceMap[target] = [];
        }
  
        if (!targetSourceMap[target].includes(source)) {
          targetSourceMap[target].push(source);
        }
      }
    });
  
    // Step 3: Filter for targets with more than one unique source
    const result = Object.entries(targetSourceMap)
      .filter(([_, sources]) => sources.length > 1)
      .map(([targetId, sourceIds]) => {
        
        const sourceNodes = sourceIds
          .map(sourceId => nodes.nod.find(n => n.id === sourceId))
          .filter(Boolean);
  
        return {
          targetId,
          sources: sourceNodes
        };
      });
  
    // Step 4: Validation: check attendantNode code consistency
    for (const { sources } of result) {
      const attendantCodes = sources
        .filter(node => node.type === "attendantNode")
        .map(node => node.data?.selected_object?.code)
        .filter(code => code !== undefined);
  
      const firstCode = attendantCodes[0];
      const allSame = attendantCodes.every(code => code === firstCode);
  
      if (!allSame) {
        return true;  
      }
    }
  
    return false; 
  }

  function aaTimeoutPointiing(nodes, edges) {
    const directoryNodeIds = nodes.nod
      .filter(node => node.type === "directoryNode")
      .map(node => node.id);

    const result = [];

    for (let dirId of directoryNodeIds) {
      const hasTimeoutEdge = edges.edg.some(edge =>
        edge.target === dirId && edge.sourceHandle === "minus1"
      );
      if (hasTimeoutEdge) {
        result.push(dirId);
      }
    }

    return result;
  }

  const AAtimeout = ({ nod }, { edg }) => {
    const attendantNodeIds = nod
      .filter(({ type }) => type === "attendantNode")
      .map(({ id }) => id);

    return edg
      .filter(({ source, sourceHandle }) =>
        attendantNodeIds.includes(source) && sourceHandle === "minus1"
      )
      .some(({ target }) =>
        nod.some(({ id, type }) => id === target && type !== "operatorNode")
      );
  };

  function hasSelfLoop(edges) {
    if (!edges?.edg || !Array.isArray(edges.edg)) return false;
  
    return edges.edg.some(edge => edge.source === edge.target);
  }
  
  
  const save = async (closeFlg, is_draft, no_message, tempNode) => {
    let sFilterEdges = [];
    let savableEdgs = [];
    let isValid = false;
    if (disablesave) {
      return;
    }
    setdisablesave(true);
    try {
    /*****Filter no target & source nodes edges*/
    console.log(is_draft);
    if (is_draft == 1) {
      isValid = true;
    } else {
      isValid = valid();
    }
    console.log("errorNodes ::::   ::: " + JSON.stringify(errorNodes));
    console.log("Is Valid ::: " + isValid);

    if (errorNodes.length > 0) {
      const invalidNode = errorNodes.find(nod =>
        nod.type === "operatorNode" || nod.type === "directoryNode"
      );
    
      if (invalidNode) {
        props.onmsg("13", invalidNode.error);
        return;
      }
    }
    if (!isValid) {
      props.onmsg();
      return;
    }
    edges.map((edg) => {
      try {
        let isconnExists =
          nodes.filter((nd) => nd.id + "" === edg.target + "").length > 0 &&
          nodes.filter((nd) => nd.id + "" === edg.source + "").length > 0;
        if (isconnExists) {
          sFilterEdges.push(edg);
        }
      } catch (e) { }
    });


    // We Comment out this traverseJson methood for solving some issue

    //   let latestNd1 = removeInvalidKeys(
    //     traverseJson(removeDuplicateNodes(nodes))
    //   );

    let latestNd1 = nodes;

    let latestNd = latestNd1.map((item) =>
      tempNode && item.id === tempNode.id ? tempNode : item
    );
    let currectnode = { nod: latestNd };
    let currentedge = { edg: traverseJson(sFilterEdges) };

    console.log("Curreent node :::::::" , JSON.stringify(currectnode));
    console.log("Curreent edge :::::::" , JSON.stringify(currentedge));
     let selfloop = hasSelfLoop(currentedge);
    if (selfloop) {
      props.onmsg("17");
      return;
    }

    let huntNodesWithNoTarget = findHuntNodeEdgesWithoutTarget(
      currectnode,
      currentedge
    );
    if (huntNodesWithNoTarget.length > 0) {
      props.onmsg("10");
      return;
    }
    let extcount = findeExternalnumberTarget(currectnode, currentedge);
    if (extcount > 0) {
      props.onmsg("11");
      return;
    }
    let operatorDirectoryerror = findOperatorDirectorySources(currectnode , currentedge) 
    if(operatorDirectoryerror){
      props.onmsg("14");
      return;
    }
    let aaTimeout = aaTimeoutPointiing(currectnode , currentedge) ; 
    if(aaTimeout && aaTimeout.length > 0){
      props.onmsg("15");
      return;
    }
    // let aaTimeoutNodemissmatch = AAtimeout(currectnode , currentedge); 
    // if (aaTimeoutNodemissmatch){
    //   props.onmsg("16");
    //   return;
    // }

     let duplicateNodeResult = findDuplicateNodesWithDifferentTargets(
      currectnode,
      currentedge
    );
    if (duplicateNodeResult.hasError) {
      props.onmsg("19", duplicateNodeResult);
      return;
    }
    

    console.log(latestNd);
    const updates = {
      reqid: 55,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      call_flow_id:
        callflow && callflow.call_flow_id ? callflow.call_flow_id : -1,
      nodes: { nod: latestNd },
      edges: { edg: traverseJson(sFilterEdges) },
      is_draft: is_draft ? 1 : 0,
    };

    console.log(JSON.stringify(updates));
    let saverep = await updateCallFlows(updates);
    console.log(saverep);

    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (is_draft == 1) {
        if (no_message != 1) {
          localStorage.setItem(
            "s_message",
            callflow.name + " saved as draft successfully."
          );
        }
      } else {
        localStorage.setItem(
          "s_message",
          callflow.name + " saved successfully."
        );
      }

      if (closeFlg == 1) {
        props.onssmesg();
        setTimeout(() => {
          window.close();
        }, 2000);
      } else {
        if (no_message != 1) {
          window.location.reload();
        }
      }
      return;
    }
    } finally {
      setdisablesave(false);
    }
  };

  const [selFlow, setSelFlow] = useState(-1);
  const [showWarning, setShowWarning] = useState(false);
  const toggleWarning = () => setShowWarning(!showWarning);
  const [isrefresh, setisrefresh] = useState(false);
  const togglerefresh = () => setisrefresh(!isrefresh);

  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);
  const [feedbackText, setFeedbackText] = useState("");
  const [errors, setErrors] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setFeedbackText(value);

    // Remove the error message when field is not empty
    if (value.trim() !== "") {
      setErrors("");
    }
  };
  const submitFeedback = async () => {
    // Check if feedback is empty and set error, otherwise proceed
    if (feedbackText.trim() === "") {
      setErrors("Feedback cannot be empty!");
      return;
    }
    // Proceed with feedback submission only if the field is not empty
    const feedbackData = {
      reqid: 139,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      feedback: feedbackText,
      who: JSON.parse(sessionStorage.getItem("admin_session")).logined_user,
    };
    const response = await callflowFeedback(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      feedbackData
    );
    if (response.status === 200) {
      props.onmsg("5");
      setFeedbackText("");
      setErrors("");
      setBasicModal(false);
    }
  };
  const feedBackClose = () => {
    setFeedbackText(""); // Clear feedback text
    setErrors(""); // Clear any existing errors
    setBasicModal(false); // Close the modal
  };

  return (
    <React.Fragment>
      <div className="d-none">
        <BlackMode />
      </div>
      <section>
        <div className="CallFlowMain">
          <div className=" ps-4 pe-2 pt-3 pb-0">
            <MDBRow>
              <div className="w-10  w-sm-15 float-left">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="general-settings">{t("Nodes")}</div>
                  {/* <MDBBtn size="sm" onClick={goBacktoCFL}>
                      <MDBIcon fas icon="arrow-left" className="me-2" /> Back
                    </MDBBtn> */}
                </div>
                <CFNodes
                  onDragStart={onDragStart}
                  onClick={onNodeClick}
                  nodes={nodes}
                />
              </div>
              <div className="w-90 w-sm-85  float-left">
                <div className="d-flex callFlow_MenuBar mb-2">
                  <CFFileMenu
                    onClose={goBacktoCFL}
                    paste={canPaste}
                    copy={canCopy}
                    cut={canCopy}
                    onPaste={cpaste}
                    onCopy={copy}
                    onCut={cut}
                    cando={canUndo}
                    redo={canRedo}
                    onUndo={undo}
                    onRedo={redo}
                    onSave={save}
                    zoomIn={zoomInFunction}
                    zoomOut={zoomOutFunction}
                    onNodeAlign={onLayout}
                    fitFull={handleCenterTransform}
                    fitS={handleTransform}
                    onNoteshide={toggleNotes}
                    hide={hidden}
                    feedBack={toggleOpen}
                  />{" "}
                  <div className="d-flex align-items-center  cursor-pointer">
                    <div className="d-flex align-items-center">
                      <div className="CallFlowdrop-down">
                        <MDBDropdown className="shadow-0">
                          <MDBDropdownToggle
                            tag="a"
                            responsive="lg-end"
                            color="link"
                          >
                            <spam className="m-0 fw-bold me-1">
                              {callflow.name}
                            </spam>

                            <MDBIcon fas icon="angle-down" className="ms-1" />
                          </MDBDropdownToggle>
                          <MDBDropdownMenu
                            className="dropdown-menu-right"
                            responsive="lg-start"
                            style={{ maxHeight: "320px", overflow: "auto" }}
                          >
                            {localStorage.getItem("callflowState") &&
                              JSON.parse(
                                localStorage.getItem("callflowState")
                              ) &&
                              JSON.parse(localStorage.getItem("callflowState"))
                                .callflow_list &&
                              JSON.parse(
                                localStorage.getItem("callflowState")
                              ).callflow_list.map((tcallflow) => (
                                <>
                                  <MDBDropdownItem
                                    link
                                    onClick={(e) =>
                                      loadVisualEditor(e, tcallflow)
                                    }
                                  >
                                    {tcallflow.name}
                                  </MDBDropdownItem>
                                </>
                              ))}
                          </MDBDropdownMenu>
                        </MDBDropdown>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between ">
                    <MDBBtn
                      size="sm"
                      className="me-2"
                      onClick={(e) => {
                        e.preventDefault();
                        refreshClick();
                      }}
                      // disabled={canUndo}
                      title="refresh"
                    >
                      <img src={RefreshNew} alt="" />
                    </MDBBtn>
                    <MDBBtn
                      size="sm"
                      className="me-2"
                      onClick={undo}
                      disabled={canUndo}
                      title="Undo"
                    >
                      {/* <MDBIcon fas icon="undo-alt" /> */}
                      <img src={UndoImg} alt="" />
                    </MDBBtn>
                    <MDBBtn
                      size="sm"
                      className="me-2"
                      onClick={redo}
                      disabled={canRedo}
                      title="Redo"
                    >
                      <img src={RedoImg} alt="" />
                      {/* <MDBIcon fas icon="redo-alt" /> */}
                    </MDBBtn>
                    {/* <MDBBtn
                      size="sm"
                      className="me-2"
                      disabled={true}
                      onClick={redo}
                    >
                      <MDBIcon
                        fas
                        icon="chart-line"
                        onClick={toggleAnalyticsLabel}
                      />
                    </MDBBtn> */}
                    {/* <MDBBtn
                      size="sm"
                      className="mx-2"
                      onClick={toggleAnalytics}
                    >
                      Call Analytics
                    </MDBBtn> */}
                    <MDBBtn size="sm" className="mx-2" onClick={saveAsDraft}>
                      Save as Draft
                    </MDBBtn>
                    <MDBBtn size="sm" className="mx-2" onClick={save} disabled={disablesave}>
                      Save
                    </MDBBtn>

                    <MDBBtn
                      size="sm"
                      color="secondary"
                      className="me-2"
                      onClick={(e) => {
                        e.preventDefault();
                        goBacktoCFL();
                      }}
                    >
                      Close
                    </MDBBtn>
                  </div>
                </div>

                <div
                  className={`Flow ${showAnalytics ? "w-85" : "w-100 reactflow-wrapper"
                    } float-left reactflow-wrapper`}
                  ref={reactFlowWrapper}
                >
                  {onloadAligned && (<>
                  <ReactFlow
                    className="react-flow"
                    key={refresh ? "refresh1" : "refresh2"}
                    nodes={nodes}
                    nodeTypes={nodeTypes}
                    onNodeClick={onRNodeClick}
                    onPaneClick={onRPanelClick}
                    edges={edges}
                    onNodesChange={onNodesChange}
                    onEdgesChange={onEdgesChange}
                    snapToGrid
                    onEdgesDelete={onDelete}
                    onEdgeClick={onEdgeClick}
                    onReconnect={onReconnect}
                    onReconnectStart={onReconnectStart}
                    onReconnectEnd={onReconnectEnd}
                    onNodeDragStart={onNodeDragStart}
                    onNodeDrag={onNodeDrag}
                    onNodeDragStop={onNodeDragStop}
                    onSelectionDragStart={onSelectionDragStart}
                    defaultEdgeOptions={defaultEdgeOptions}
                    onConnect={(params) => onConnect(params, edges)}
                    onNodesDelete={onNodesDelete}
                    onInit={setReactFlowInstance}
                    onNodeMouseMove={onNodeMouseEnter}
                    onNodeMouseLeave={onNodeMouseLeave}
                    zoom={1}
                    attributionPosition="bottom-left"
                    onDrop={onDrop}
                    onDragOver={onDragOver}
                    selectNodesOnDrag={true}
                    zoomOnScroll={true}
                  >
                    <Background
                      className="CallFlowGrids"
                      variant="dots"
                      gap={15}
                    />
                    {/* <MiniMap /> */}
                    <Controls />
                  </ReactFlow>
                  </>)}
                </div>

                {showAnalytics && (
                  <CFAnalytics toggleAnalytics={toggleAnalytics} />
                )}
              </div>
            </MDBRow>

            {/*************** Related Popups ******************************************************/}
            {newSchedule && (
              <PopupLoader
                size="lg"
                className="modal-lg"
                title="Create New Schedule"
                content={
                  <WeelySchedulePopup
                    onCreate={onNewSchedule}
                    onClose={() => handleClose("schedule")}
                    node={currentNode}
                    isLuna = {false}
                    timezone={locationTZ}
                  />
                }
                onShow={setNewSchedule}
                open={newSchedule}
                onClose={() => handleClose("schedule")}
              />
            )}
            {editSchedule && (
              <PopupLoader
                size="lg"
                className="modal-lg"
                title="Edit Schedule"
                content={
                  <SchduleView
                    ref={scheduleEditRef}
                    onSave={onNewSchedule}
                    onClose={() => handleClose("schedule-edit")}
                    schid={schd}
                    node={editcurrent}
                    onValidationChange={(hasError) => setScheduleEditError(hasError)}
                  />
                }
                footer={
                  <>
                    <MDBBtn color="secondary" onClick={() => handleClose("schedule-edit")}>
                      Close
                    </MDBBtn>
                    <MDBBtn
                      onClick={() => {
                        if (scheduleEditRef.current) {
                          scheduleEditRef.current.saveSchedule();
                        }
                      }}
                      disabled={scheduleEditError}
                    >
                      Save
                    </MDBBtn>
                  </>
                }
                onShow={setEditSchedule}
                open={editSchedule}
                onClose={() => handleClose("schedule-edit")}
              />
            )}
            {newHuntGroup && (
              <PopupLoaderNew
                // size="lg"
                // className="modal-lg"
                title="Create New Hunt Group"
                content={
                  <AddHuntGroup
                    onClose={() => handleClose("hunt")}
                    onSuccess={updateVE}
                    tnode={currentNode}
                    ref={addHuntRef}
                    setIsloading={setisLoading}
                  // destination = {"callflow"}
                  />
                }
                onShow={setNewHuntGroup}
                onClose={() => handleClose("hunt")}
                onSave={handleClick}
                isloading={isLoading}
                flag={1}
              />
            )}
            {newACDGroup && (
              <PopupLoader
                size="lg"
                // className="modal-lg"
                title="Create New ACD Group"
                content={
                  <AddACDGroup
                    onClose={() => handleClose("hunt")}
                    onSuccess={updateVE}
                  />
                }
                onShow={setNewACDGroup}
                onClose={() => handleClose("acd")}
              />
            )}
            {newVMBox && (
              <PopupLoader
                size="lg"
                // className="modal-lg"
                title="Create New Voicemail Box"
                content={
                  <AddNewVMBox
                    onClose={() => handleClose("vmail")}
                    tnode={currentNode}
                    onSuccess={updateVE}
                  />
                }
                onShow={setNewVMBox}
                onClose={() => handleClose("vmail")}
              />
            )}
            {newAAGroup && (
              <PopupLoaderNew
                title="Create New Auto Attendant"
                content={
                  <AddAAGroup
                    onClose={() => handleClose("aa")}
                    onSuccess={updateVE}
                    tnode={currentNode}
                    ref={addHuntRef}
                    setIsloading={setisLoading}
                  // destination = {"callflow"}
                  />
                }
                onShow={setNewAAGroup}
                onClose={() => handleClose("aa")}
                onSave={handleClick}
                isloading={isLoading}
                flag={1}
              />
            )}
            {editGreeting && (
              <PopupLoader
                size="lg"
                title={"Edit"}
                content={
                  <Greeting
                    uniqueId={
                      currentNode.data && currentNode.data.selected_object
                        ? currentNode.data.selected_object.code
                        : -1
                    }
                    greetingType={
                      currentNode.type == "announcementNode" ? 5 : 4
                    }
                    existingGreetings={existingGreetings.pre_announce}
                    greetingMode={
                      currentNode.type == "announcementNode" ? 1 :
                      currentNode?.data.info
                        ? currentNode.data.info.pre_announce.greeting_mode 
                        : currentNode?.data?.greetinfo?.pre_announce?currentNode?.data?.greetinfo?.pre_announce.greeting_mode : 2
                    }
                    title="Greeting"
                    setPlayerPath={setPlayerPath}
                    setgeetingTitle={setgeetingTitle}
                    onClose={() => handleClose("greeting")}
                    setApiResponse={greetingSuccess}
                    huntFlag={currentNode.type == "announcementNode" ? true : false}
                    greetingObject={currentNode.type == "announcementNode" && currentNode?.data?.greet_info && currentNode?.data?.greet_info?.uploadType === 3 ? currentNode?.data?.greet_info : currentNode?.data?.greetinfo?.pre_announce && currentNode?.data?.greetinfo?.pre_announce?.uploadType === 3 ? currentNode?.data?.greetinfo?.pre_announce : null }
                    ttswavFile={currentNode.type == "announcementNode" ?  (currentNode.data.selected_object?.g_wav_file ?? null) : (currentNode.data.selected_object.g_wav_file  ?? null)}
                    callFlowFlag={true}
                    AnnounceCalFlow = {currentNode.type == "announcementNode" ? true : false}
                  />
                }
                onClose={toggleCFilterEGreet}
              />
            )}
            {callerFilter && (
              <PopupLoader
                size="md"
                className="modal-md"
                title={t("addFilter")}
                content={
                  <>
                    <AddCallerID
                      toggleCFilter={toggleCFilter}
                      addCFilter={addCFilter}
                      existingFilters={nodes.find((n) => n.id === currentNode?.id)?.data?.handles || []}
                    />
                  </>
                }
                onShow={setCallerFilter}
                onClose={() => handleClose("cf")}
              />
            )}

            {callerEditFilter && (
              <PopupLoader
                size="md"
                className="modal-md"
                title={t("editFilter")}
                content={
                  <>
                    <EditCallerID
                      editData={editSpechandle}
                      toggleCFilter={toggleEditFilter}
                      addCFilter={addCFilter}
                      existingFilters={nodes.find((n) => n.id === currentNode?.id)?.data?.handles || []}
                    />
                  </>
                }
                onShow={setCallerEditFilter}
                onClose={() => handleClose("cfEdit")}
              />
            )}

            <MDBModal open={isrefresh} setOpen={setisrefresh} tabIndex="-1">
              <MDBModalDialog>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>{t("Warning")}</MDBModalTitle>
                    <MDBBtn
                      className="btn-close"
                      color="none"
                      onClick={togglerefresh}
                    ></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                      <MDBIcon
                        fas
                        icon="exclamation-triangle"
                        className="me-3 fs-5 mt-1"
                        color="warning"
                      />
                      <div>
                        There are unsaved changes. Are you sure you want to
                        refresh the page?
                      </div>
                    </div>
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn color="secondary" onClick={togglerefresh}>
                      {t("cancel")}
                    </MDBBtn>
                    <MDBBtn
                      onClick={() => {
                        goBacktoCFL("ref");
                      }}
                    >
                      {t("ok")}
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
            <MDBModal open={showWarning} setOpen={setShowWarning} tabIndex="-1">
              <MDBModalDialog>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>{t("Warning")}</MDBModalTitle>
                    <MDBBtn
                      className="btn-close"
                      color="none"
                      onClick={toggleWarning}
                    ></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                      <MDBIcon
                        fas
                        icon="exclamation-triangle"
                        className="me-3 fs-5 mt-1"
                        color="warning"
                      />
                      <div>
                        There are unsaved changes. Are you sure you want to
                        navigate away?
                      </div>
                    </div>
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn color="secondary" onClick={toggleWarning}>
                      {t("cancel")}
                    </MDBBtn>
                    <MDBBtn
                      onClick={() => {
                        goBacktoCFL(selFlow == -1 ? 1 : 2, selFlow);
                      }}
                    >
                      {t("ok")}
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

            <MDBModal
              open={basicModal}
              onClose={() => feedBackClose()}
              tabIndex="-1"
            >
              <MDBModalDialog>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Feedback</MDBModalTitle>
                    <MDBBtn
                      className="btn-close"
                      color="none"
                      onClick={() => feedBackClose()}
                    ></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody>
                    <label htmlFor="">{t("FeedbackTxt")}</label>

                    <MDBTextArea
                      rows={4}
                      value={feedbackText}
                      onChange={(e) => handleChange(e)}
                    />
                    {errors && (
                      <p className="text-danger text-start ms-2">{errors}</p>
                    )}
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn color="secondary" onClick={() => feedBackClose()}>
                      Close
                    </MDBBtn>
                    <MDBBtn onClick={() => submitFeedback()}> Submit </MDBBtn>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          </div>
        </div>
      </section>
      {disablesave && (
        <div>
          <div className="loadingclass-popup"></div>
          <div className="popup-bg-loader loader_align">
            <MDBBtn disabled>
              <MDBSpinner
                size="sm"
                role="status"
                tag="span"
                className="me-2"
              />
              Loading...
            </MDBBtn>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
function VisualEditorNew(props) {
  const [message, setMessage] = useState(null);
  const [name, setName] = useState("");
  const [emessage, setEMessage] = useState(null);
  const [sucessmsg, setSucessmsg] = useState(null);
  const stringToBoolean = (str) => {
    return str.toLowerCase() === "true";
  };
  const [appLoading, setAppLoading] = useState(false);
  const shload = (status) => {
    if (status + "" == "true") {
      setAppLoading(true);
    } else if (status + "" == "false") {
      setAppLoading(false);
    }
  };
  const setcName = (name) => {
    setName(name);
  };
  const setErrorMSg = (msg, enode) => {
    // Check for each message type and set the appropriate message
    switch (msg) {
      case "4":
        console.log("Existing node " + JSON.stringify(enode));
        setEMessage(`Error: ${enode.existingnode.title} is already in use.`);
        break;
      case "5":
        setSucessmsg(
          "Thanks for your feedback! We'll get back to you shortly."
        );
        break;
      case "10":
        setEMessage("A hunt group must have a fallback destination.");
        break;
      case "11":
        setEMessage(
          "An external number fallback must not be set to another external number. Please change the option to a different node."
        );
        break;
      case "12":
        setSucessmsg(
          `${enode} has been updated successfully. Please refresh the page to see the recent changes.`
        );
        break;
        case "13":
        setEMessage(
         `${enode}`
        );
        break;
        case "14":
        setEMessage(
         `The same operator or directory node cannot have edges connected to multiple source nodes.`
        );
        break;
        case "15":
          setEMessage(
           `A Directory node cannot be set as a Timeout destination for an Auto Attendant. Please choose a valid destination.`
          );
          break;
          case "16":
            setEMessage(
             `An Auto Attendant timeout destination must be an Operator node.`
            );
            break;
            case "17":
            setEMessage(
             `Self-loops are not allowed. Please connect this node to a different target.`
            );
            break;
            case "18":
            setEMessage(
             `Self-loops are not allowed. Please connect this node to a different target.`
            );
        break;
      case "19":
        setEMessage(
          `Unable to save the callflow. The ${enode.nodeTypeLabel} node ${enode.nodeName} is assigned to different destinations. All ${enode.nodeTypeLabel}  ${enode.nodeName} nodes must point to the same target.`
        );
        break;
      default:
        setEMessage(
          "The red highlighted nodes are experiencing errors because they either lack destination nodes or destination objects. Please correct them in order to proceed further and save"
        );
        break;
    }

    setTimeout(() => {
      setEMessage(null);
      setSucessmsg(null);
    }, 10000);
  };

  const setSSuccessMSg = () => {
    if (localStorage.getItem("s_message")) {
      setMessage(localStorage.getItem("s_message"));
      setTimeout(() => {
        setMessage(null);

        localStorage.removeItem("s_message");
      }, 2000);
    }
    if (localStorage.getItem("f_message")) {
      setEMessage(localStorage.getItem("f_message"));
      setTimeout(() => {
        setEMessage(null);
        localStorage.removeItem("f_message");
      }, 2000);
    }
  };

  const setSuccessMSg = () => {
    if (localStorage.getItem("s_message")) {
      setMessage(localStorage.getItem("s_message"));
      setTimeout(() => {
        setMessage(null);
        localStorage.removeItem("s_message");
      }, 2000);
    }
    if (localStorage.getItem("f_message")) {
      setEMessage(localStorage.getItem("f_message"));
      setTimeout(() => {
        setEMessage(null);
        localStorage.removeItem("f_message");
      }, 2000);
    }

    setTimeout(() => {
      setEMessage(null);
    }, 10000);
  };
  useEffect(() => {
    if (localStorage.getItem("s_message")) {
      setMessage(localStorage.getItem("s_message"));
      setTimeout(() => {
        setMessage(null);

        localStorage.removeItem("s_message");
      }, 2000);
    }
    if (localStorage.getItem("f_message")) {
      setEMessage(localStorage.getItem("f_message"));
      setTimeout(() => {
        setEMessage(null);
        localStorage.removeItem("f_message");
      }, 2000);
    }
  }, []);

  return (
    <>
      {message && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={100000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{message}</span>
        </MDBAlert>
      )}
      {emessage && (
        <MDBAlert
          open
          className="alert-center alert-popup w-30 shadow-1"
          color="danger"
          autohide
          position="bottom-right"
          delay={150000}
        >
          <span className="alert-msgnonc">{emessage}</span>
        </MDBAlert>
      )}
      {sucessmsg && (
        <MDBAlert
          open
          className="alert-center alert-popup w-30 shadow-1"
          color="success"
          autohide
          position="bottom-right"
          delay={15000}
        >
          <span className="alert-msgnonc">{sucessmsg}</span>
        </MDBAlert>
      )}
      <ReactFlowProvider>
        <CallFlow
          {...props}
          onsmesg={setSuccessMSg}
          onssmesg={setSSuccessMSg}
          onmsg={setErrorMSg}
          showload={shload}
          setcName={setcName}
        />
      </ReactFlowProvider>
      {appLoading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
}
export default VisualEditorNew;